"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SUBREPO_CONFIG: function() {
        return SUBREPO_CONFIG;
    },
    ExploreMultiV2Sk: function() {
        return ExploreMultiV2Sk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _dataservice = require("../data-service");
const _aloginsk = require("../../../infra-sk/modules/alogin-sk/alogin-sk");
const _chartlogic = require("./chart-logic");
const _fetchlogic = require("./fetch-logic");
const _query = require("../../../infra-sk/modules/query");
const _const = require("../const/const");
const _graphconfig = require("../common/graph-config");
const _stateReflector = require("../../../infra-sk/modules/stateReflector");
const _paramtools = require("../paramtools");
require("./query-bar-sk");
require("./trace-chart-sk");
require("./plot-summary-v2-sk");
const _telemetry = require("../telemetry/telemetry");
const _types = require("../telemetry/types");
const _db = require("./db");
require("./explore-toolbar-sk");
const _exploreworkercontroller = require("./explore-worker-controller");
const _errorMessage = require("../errorMessage");
require("./help-hub-sk");
require("./interactive-tour-sk");
require("../window/window");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _ExploreMultiV2Sk;
const MAX_VISIBLE_TRACES = 500;
const SUBREPO_CONFIG = {
    V8: {
        logUrl: 'https://chromium.googlesource.com/v8/v8.git/+log/',
        repoUrl: 'https://chromium.googlesource.com/v8/v8.git/+/'
    },
    WebRTC: {
        logUrl: 'https://webrtc.googlesource.com/src.git/+log/',
        repoUrl: 'https://webrtc.googlesource.com/src.git/+/'
    },
    Skia: {
        logUrl: 'https://skia.googlesource.com/skia.git/+log/',
        repoUrl: 'https://skia.googlesource.com/skia.git/+/'
    },
    Dawn: {
        logUrl: 'https://dawn.googlesource.com/dawn.git/+log/',
        repoUrl: 'https://dawn.googlesource.com/dawn.git/+/'
    },
    Angle: {
        logUrl: 'https://chromium.googlesource.com/angle/angle.git/+log/',
        repoUrl: 'https://chromium.googlesource.com/angle/angle.git/+/'
    }
};
const DEFAULT_SUMMARY_RANGE_SEC = 90 * 24 * 3600; // 90 days
const SUMMARY_INCREMENT_SEC = 90 * 24 * 3600; // 90 days
const ANOMALY_VIEWPORT_PADDING_COMMITS = 100;
let ExploreMultiV2Sk = (_ExploreMultiV2Sk = class ExploreMultiV2Sk extends _lit.LitElement {
    sanitizeQueries(queries) {
        if (!queries) return [
            {}
        ];
        return queries.map((q)=>{
            if (!q) return {};
            const clean = {};
            for (const [k, vals] of Object.entries(q)){
                if (Array.isArray(vals)) {
                    const filtered = vals.filter((v)=>v !== _const.MISSING_VALUE_SENTINEL && v !== '__missing__');
                    if (filtered.length > 0) {
                        clean[k] = filtered;
                    }
                } else if (typeof vals === 'string') {
                    const strVal = vals;
                    if (strVal !== _const.MISSING_VALUE_SENTINEL && strVal !== '__missing__') {
                        clean[k] = [
                            strVal
                        ];
                    }
                }
            }
            return clean;
        });
    }
    get queries() {
        return this._queries;
    }
    set queries(val) {
        const oldVal = this._queries;
        this._queries = this.sanitizeQueries(val);
        this._tracePage = 0;
        this._summaryBeginOffsetSec = DEFAULT_SUMMARY_RANGE_SEC;
        this._summaryEndOffsetSec = 0;
        this.requestUpdate('queries', oldVal);
    }
    connectedCallback() {
        super.connectedCallback();
        _telemetry.telemetry.increaseCounter(_types.CountMetric.ExploreMultiV2Visit);
        (0, _aloginsk.LoggedIn)().then((status)=>{
            this._user = status.email;
        }).catch((e)=>console.error('Failed to check login status', e));
        const db = new _db.TraceDatabase();
        db.evictOlderThan(30).catch((e)=>console.error('Eviction failed:', e));
        let isInitialGetState = true;
        this._stateHasChanged = (0, _stateReflector.stateReflector)(()=>{
            const stateObj = {
                shortcut: this._shortcut,
                centre: this._normalizeCentre,
                scale: this._normalizeScale,
                hoverMode: this._hoverMode,
                radius: this._smoothingRadius,
                dots: this._showDots,
                split: Array.from(this.splitKeys).join(','),
                diff_base: this._diffBase ? `${this._diffBase.key}=${this._diffBase.value}` : '',
                sparklines: this.showSparklines,
                onlyRegressions: this.onlyRegressions,
                splitAll: this.splitAll,
                regressions: this.showRegressions,
                tooltipDiffs: this._tooltipDiffs,
                evenXAxisSpacing: this._evenXAxisSpacing,
                showZero: this._showZero,
                transformPreset: this._transformPreset,
                dateMode: this.dateMode,
                page: this._tracePage,
                pageSize: this.pageSize,
                showAll: this._showAllTraces,
                subrepo: this._selectedSubrepo,
                edgeFactor: this._edgeDetectionFactor,
                outlier: this._edgeLookahead,
                begin: this.begin,
                end: this.end,
                formulas: this._formulasPerQuery.map((p)=>p ? p.join(':') : '').join(',')
            };
            // Dynamically preserve all non-managed query parameters from the URL (e.g., from report-page or other elements)
            const urlParams = new URLSearchParams(window.location.search);
            const managedKeys = new Set(Object.keys(stateObj));
            urlParams.forEach((value, key)=>{
                if (!managedKeys.has(key)) {
                    stateObj[key] = value;
                }
            });
            if (isInitialGetState) {
                isInitialGetState = false;
                // Exclude non-managed keys on the very first capture so stateReflector registers them as dirty/always-serialize
                urlParams.forEach((_, key)=>{
                    if (!managedKeys.has(key)) {
                        delete stateObj[key];
                    }
                });
            }
            return stateObj;
        }, (o)=>{
            const stateObj = o;
            if (stateObj.shortcut) {
                this._shortcut = stateObj.shortcut;
                void this._loadShortcut(this._shortcut);
            } else {
                this._shortcut = stateObj.shortcut || '';
                if (stateObj.qs !== undefined) {
                    console.log('explore-multi-v2-sk: Raw qs from URL:', stateObj.qs);
                    try {
                        const parsed = JSON.parse(stateObj.qs);
                        if (Array.isArray(parsed)) {
                            this.queries = parsed;
                        } else if (typeof parsed === 'object' && parsed !== null) {
                            console.log('explore-multi-v2-sk: Wrapping object query in array');
                            this.queries = [
                                parsed
                            ];
                        } else {
                            console.log('explore-multi-v2-sk: Invalid qs type:', typeof parsed);
                            this.queries = [
                                {}
                            ];
                        }
                    } catch (e) {
                        console.error('explore-multi-v2-sk: Failed to parse qs from URL:', e);
                        this.queries = [
                            {}
                        ];
                    }
                } else if (stateObj.q !== undefined) {
                    this.queries = [
                        (0, _query.toParamSet)(stateObj.q)
                    ];
                }
            }
            if (stateObj.formulas !== undefined && typeof stateObj.formulas === 'string') {
                this._formulasPerQuery = stateObj.formulas.split(',').map((str)=>str && str !== 'none' ? str.split(':') : []);
            }
            if (stateObj.centre !== undefined) this._normalizeCentre = stateObj.centre;
            if (stateObj.scale !== undefined) this._normalizeScale = stateObj.scale;
            if (stateObj.hoverMode !== undefined) {
                this._hoverMode = stateObj.hoverMode;
                this._smooth = this._hoverMode === 'both' || this._hoverMode === 'smoothed';
            }
            if (stateObj.radius !== undefined) this._smoothingRadius = stateObj.radius;
            if (stateObj.dots !== undefined) this._showDots = stateObj.dots;
            if (stateObj.split !== undefined) {
                this.splitKeys = new Set(stateObj.split ? stateObj.split.split(',') : []);
            }
            if (stateObj.diff_base) {
                const parts = stateObj.diff_base.split('=');
                if (parts.length === 2) {
                    this._diffBase = {
                        key: parts[0],
                        value: parts[1]
                    };
                }
            } else {
                this._diffBase = null;
            }
            if (stateObj.sparklines !== undefined) this.showSparklines = stateObj.sparklines;
            if (stateObj.onlyRegressions !== undefined) this.onlyRegressions = stateObj.onlyRegressions;
            if (stateObj.splitAll !== undefined) this.splitAll = stateObj.splitAll;
            if (stateObj.regressions !== undefined) this.showRegressions = stateObj.regressions;
            if (stateObj.tooltipDiffs !== undefined) this._tooltipDiffs = stateObj.tooltipDiffs;
            if (stateObj.evenXAxisSpacing !== undefined) this._evenXAxisSpacing = stateObj.evenXAxisSpacing;
            if (stateObj.showZero !== undefined) this._showZero = stateObj.showZero;
            if (stateObj.transformPreset !== undefined) this._transformPreset = stateObj.transformPreset;
            if (stateObj.dateMode !== undefined) this.dateMode = stateObj.dateMode;
            if (stateObj.page !== undefined) this._tracePage = stateObj.page;
            if (stateObj.pageSize !== undefined) this.pageSize = stateObj.pageSize;
            if (stateObj.showAll !== undefined) this._showAllTraces = stateObj.showAll;
            if (stateObj.subrepo !== undefined) this._selectedSubrepo = stateObj.subrepo;
            if (stateObj.edgeFactor !== undefined) this._edgeDetectionFactor = stateObj.edgeFactor;
            if (stateObj.outlier !== undefined) this._edgeLookahead = stateObj.outlier;
            if (stateObj.begin !== undefined) this.begin = Number(stateObj.begin);
            if (stateObj.end !== undefined) this.end = Number(stateObj.end);
        }, true);
        this._initWorker();
        window.addEventListener('anomalies-source-changed', this._onAnomaliesSourceChanged);
        this.addEventListener('anomaly-changed', this._onAnomalyChanged);
    }
    disconnectedCallback() {
        if (this._prefetchAbortController) {
            this._prefetchAbortController.abort();
        }
        if (this._workerController) {
            this._workerController.terminate();
        }
        if (this._workerFilterTimer !== null) {
            window.clearTimeout(this._workerFilterTimer);
        }
        if (this._fetchDataTimer !== null) {
            window.clearTimeout(this._fetchDataTimer);
        }
        if (this._fetchMetadataTimer !== null) {
            window.clearTimeout(this._fetchMetadataTimer);
        }
        window.removeEventListener('anomalies-source-changed', this._onAnomaliesSourceChanged);
        this.removeEventListener('anomaly-changed', this._onAnomalyChanged);
        super.disconnectedCallback();
    }
    _initWorker() {
        this._workerInitializing = true;
        this._loading = true;
        this._statusMessage = 'Starting worker...';
        this._workerController = new _exploreworkercontroller.ExploreWorkerController(()=>{
            console.log('Orchestrator: Worker loaded');
        }, ()=>{
            console.log('Orchestrator: Worker ready');
            this._workerInitializing = false;
            this._latestRequestId = this._triggerWorkerFilter();
        }, (payload)=>{
            console.log(`Worker Progress [${payload.name}]: ${payload.loaded}/${payload.total}`);
        }, (message)=>{
            console.error('Worker Error:', message);
            this._loading = false;
            this._statusMessage = '';
            this._workerInitializing = false;
            this._isCalculatingCounts = false;
            (0, _errorMessage.errorMessage)(`Worker initialization failed: ${message}`);
        }, (payload)=>{
            console.log('Worker Params Ready');
            if (payload.availableParams) {
                this._availableParams = payload.availableParams;
                this._globalAvailableParams = payload.availableParams;
            }
            if (payload.paramsByKey) {
                this._optionsByKey = payload.paramsByKey;
                this._globalOptionsByKey = payload.paramsByKey;
            }
        }, (payload)=>{
            this._handleFilterResult(payload);
        }, (payload, idx, requestId)=>{
            if (requestId !== this._latestSuggestRequestIds[idx]) {
                return;
            }
            const newSuggestions = [
                ...this._suggestionsForQueryBar
            ];
            newSuggestions[idx] = payload;
            this._suggestionsForQueryBar = newSuggestions;
        }, (message)=>{
            this._statusMessage = message;
        });
        this._workerController.init();
    }
    _handleFilterResult(payload) {
        console.log('Worker Filter Result:', payload.filteredCount);
        if (payload.requestId !== undefined && payload.requestId !== this._latestRequestId) {
            console.log(`Discarding stale worker result: expected ${this._latestRequestId}, got ${payload.requestId}`);
            return;
        }
        const reconstructedIds = [];
        if (payload.results) {
            payload.results.forEach((r)=>{
                const paramsObj = {};
                r.params.forEach((p)=>{
                    paramsObj[p.key] = p.value;
                });
                try {
                    const key = (0, _paramtools.makeKey)(paramsObj);
                    reconstructedIds.push(key);
                } catch (err) {
                    console.error('Failed to construct key for trace:', r.index, err);
                }
            });
        }
        const queryObj = this.queries[0];
        const hasFilters = queryObj ? Object.values(queryObj).some((arr)=>arr && arr.length > 0) : false;
        if (!hasFilters) {
            this._matchingTraceIds = [];
            this._updateSeriesData([]);
            this._loadedBounds = {};
            this._globalBounds = {};
            this._regressions = {};
            this._loading = false;
            this._statusMessage = '';
        } else {
            this._matchingTraceIds = reconstructedIds;
            console.log(`Reconstructed ${reconstructedIds.length} matching Trace IDs`);
            void this._fetchData(this._latestRequestId);
        }
        if (payload.queryResults && payload.queryResults[0]) {
            const firstResult = payload.queryResults[0];
            if (firstResult.availableParams) {
                this._availableParams = firstResult.availableParams;
            }
            const mergedOptionsByKey = firstResult.paramsByKey ? _object_spread({}, firstResult.paramsByKey) : {};
            // Override counts for active facets with data from corresponding results
            if (payload.queryResults.length > 1 && this._latestActiveFacets.length > 0) {
                this._latestActiveFacets.forEach((key, index)=>{
                    const resultIdx = index + this.queries.length;
                    if (payload.queryResults[resultIdx]) {
                        const facetResult = payload.queryResults[resultIdx];
                        if (facetResult.paramsByKey && facetResult.paramsByKey[key]) {
                            mergedOptionsByKey[key] = facetResult.paramsByKey[key];
                        }
                    }
                });
            }
            this._optionsByKey = mergedOptionsByKey;
            // Store independent params and options for each query bar
            const availableParamsPerQuery = [];
            const optionsByKeyPerQuery = [];
            payload.queryResults.forEach((result, idx)=>{
                if (idx < this.queries.length) {
                    availableParamsPerQuery.push(result.availableParams || []);
                    if (idx === 0) {
                        optionsByKeyPerQuery.push(mergedOptionsByKey);
                    } else {
                        optionsByKeyPerQuery.push(result.paramsByKey || {});
                    }
                }
            });
            this._availableParamsPerQuery = availableParamsPerQuery;
            this._optionsByKeyPerQuery = optionsByKeyPerQuery;
        }
        this._isCalculatingCounts = false;
    }
    _triggerWorkerFilter(requestId) {
        var _this__workerController;
        if (!((_this__workerController = this._workerController) === null || _this__workerController === void 0 ? void 0 : _this__workerController.isReady())) return -1;
        this._statusMessage = ''; // Clear stale status messages from initialization.
        const queries = [
            ...this.queries
        ];
        const activeFacets = [];
        // Add one query per selected facet, with that facet removed
        for (const key of Object.keys(this.queries[0])){
            if (this.queries[0][key] && this.queries[0][key].length > 0) {
                activeFacets.push(key);
                const queryCopy = _object_spread({}, this.queries[0]);
                delete queryCopy[key];
                queries.push(queryCopy);
            }
        }
        this._latestActiveFacets = activeFacets;
        return this._workerController.filter(queries, this.queries.length, requestId);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        if (changedProperties.has('embedded') && !this._userToggledExpanded) {
            this._queriesExpanded = !this.embedded;
        }
        if (changedProperties.has('dateMode')) {
            this._initialViewportBounds = null;
        }
        if (this._initialViewportBounds === null && this.viewportMinX !== null && this.viewportMaxX !== null) {
            this._initialViewportBounds = {
                minX: this.viewportMinX,
                maxX: this.viewportMaxX
            };
        }
    }
    firstUpdated() {
        // Yield a macro-tick to guarantee stateReflector's initial stateFromURL microtask
        // completes first and sets loaded=true. This ensures resolved default/partial bounds
        // are successfully written back to the URL rather than being ignored and overwritten.
        setTimeout(()=>{
            void this._fetchMetadata();
        }, 0);
    }
    async _fetchMetadata() {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            const json = await _dataservice.DataService.getInstance().getInitPage(tz);
            const defaults = await _dataservice.DataService.getInstance().getDefaults();
            this._defaults = defaults;
            this._includeParams = defaults.include_params || [];
            this._defaultParamSelections = defaults.default_param_selections || {};
            this._conditionalDefaults = defaults.conditional_defaults || [];
            this._applyConfigDefaults(defaults);
            // Apply defaults to initial query if empty and no shortcut is present
            if (this.queries.length === 1 && Object.keys(this.queries[0]).length === 0 && !this._shortcut) {
                this.queries = [
                    _object_spread({}, this._defaultParamSelections)
                ];
            }
            if (json && json.dataframe && json.dataframe.paramset) {
                const paramset = json.dataframe.paramset;
                const optionsByKey = {};
                const availableParams = [];
                Object.keys(paramset).forEach((key)=>{
                    optionsByKey[key] = paramset[key].map((v)=>({
                            value: v,
                            count: 0
                        }));
                    paramset[key].forEach((v)=>{
                        availableParams.push({
                            key: key,
                            value: v,
                            count: 0
                        });
                    });
                });
                this._optionsByKey = optionsByKey;
                this._availableParams = availableParams;
            }
        } catch (e) {
            console.error('Metadata fetch error:', e);
        } finally{
            this._resolveTimeRange();
        }
    }
    _applyConfigDefaults(defaults) {
        if (!defaults) return;
        const urlParams = new URLSearchParams(window.location.search);
        if (defaults.default_xaxis_domain === 'date' && !urlParams.has('dateMode')) {
            this.dateMode = true;
        }
        if (defaults.default_url_values) {
            const urlVals = defaults.default_url_values;
            const stringToBool = (val)=>val.toLowerCase() === 'true';
            if (urlVals.evenXAxisSpacing !== undefined && !urlParams.has('evenXAxisSpacing')) {
                this._evenXAxisSpacing = stringToBool(urlVals.evenXAxisSpacing);
            }
            if (urlVals.showZero !== undefined && !urlParams.has('showZero')) {
                this._showZero = stringToBool(urlVals.showZero);
            }
            if (urlVals.plotSummary !== undefined && !urlParams.has('plotSummary')) {
                this._showSummaryBar = stringToBool(urlVals.plotSummary);
            }
            if (urlVals.dots !== undefined && !urlParams.has('dots')) {
                this._showDots = stringToBool(urlVals.dots);
            }
            if (urlVals.sparklines !== undefined && !urlParams.has('sparklines')) {
                this.showSparklines = stringToBool(urlVals.sparklines);
            }
            if (urlVals.onlyRegressions !== undefined && !urlParams.has('onlyRegressions')) {
                this.onlyRegressions = stringToBool(urlVals.onlyRegressions);
            }
            if (urlVals.splitAll !== undefined && !urlParams.has('splitAll')) {
                this.splitAll = stringToBool(urlVals.splitAll);
            }
            if (urlVals.regressions !== undefined && !urlParams.has('regressions')) {
                this.showRegressions = stringToBool(urlVals.regressions);
            }
            if (urlVals.tooltipDiffs !== undefined && !urlParams.has('tooltipDiffs')) {
                this._tooltipDiffs = stringToBool(urlVals.tooltipDiffs);
            }
            if (urlVals.transformPreset !== undefined && !urlParams.has('transformPreset')) {
                this._transformPreset = urlVals.transformPreset;
            }
        }
    }
    updated(changedProperties) {
        let queriesChanged = false;
        if (changedProperties.has('queries')) {
            queriesChanged = true;
        }
        const formulasChanged = changedProperties.has('_formulasPerQuery');
        const pageOrSizeChanged = changedProperties.has('_tracePage') || changedProperties.has('pageSize') || changedProperties.has('_showAllTraces');
        const needsNewRequest = queriesChanged || !queriesChanged && pageOrSizeChanged;
        if (needsNewRequest) {
            this._latestRequestId++;
        }
        const currentRequestId = this._latestRequestId;
        if (queriesChanged) {
            var _this__workerController;
            this._isCalculatingCounts = true;
            if ((_this__workerController = this._workerController) === null || _this__workerController === void 0 ? void 0 : _this__workerController.isReady()) {
                if (this._debounceDelay === 0) {
                    this._triggerWorkerFilter(currentRequestId);
                } else {
                    if (this._workerFilterTimer !== null) {
                        window.clearTimeout(this._workerFilterTimer);
                    }
                    this._workerFilterTimer = window.setTimeout(()=>{
                        this._workerFilterTimer = null;
                        this._triggerWorkerFilter(currentRequestId);
                    }, this._debounceDelay);
                }
            }
        }
        if (queriesChanged || formulasChanged) {
            void this._updateShortcut();
        }
        if (!queriesChanged && pageOrSizeChanged) {
            if (this._debounceDelay === 0) {
                void this._fetchData(currentRequestId);
            } else {
                if (this._fetchDataTimer !== null) {
                    window.clearTimeout(this._fetchDataTimer);
                }
                this._fetchDataTimer = window.setTimeout(()=>{
                    this._fetchDataTimer = null;
                    void this._fetchData(currentRequestId);
                }, this._debounceDelay);
            }
        }
        if (changedProperties.has('_seriesData') || !queriesChanged && (changedProperties.has('_tracePage') || changedProperties.has('pageSize'))) {
            if (this._debounceDelay === 0) {
                void this._fetchMetadataForVisibleTraces(currentRequestId);
            } else {
                if (this._fetchMetadataTimer !== null) {
                    window.clearTimeout(this._fetchMetadataTimer);
                }
                this._fetchMetadataTimer = window.setTimeout(()=>{
                    this._fetchMetadataTimer = null;
                    void this._fetchMetadataForVisibleTraces(currentRequestId);
                }, this._debounceDelay);
            }
        }
        if (changedProperties.has('queries') || changedProperties.has('_normalizeCentre') || changedProperties.has('_normalizeScale') || changedProperties.has('_hoverMode') || changedProperties.has('_smoothingRadius') || changedProperties.has('_showDots') || changedProperties.has('splitKeys') || changedProperties.has('_diffBase') || changedProperties.has('showSparklines') || changedProperties.has('onlyRegressions') || changedProperties.has('splitAll') || changedProperties.has('dateMode') || changedProperties.has('_tracePage') || changedProperties.has('pageSize') || changedProperties.has('_showAllTraces') || changedProperties.has('_selectedSubrepo') || changedProperties.has('_edgeDetectionFactor') || changedProperties.has('_edgeLookahead') || changedProperties.has('showRegressions') || changedProperties.has('_tooltipDiffs') || changedProperties.has('_evenXAxisSpacing') || changedProperties.has('begin') || changedProperties.has('end')) {
            this._stateHasChanged();
            this.dispatchEvent(new CustomEvent('explore-state-change', {
                bubbles: true,
                composed: true
            }));
        }
    }
    async _loadShortcut(id) {
        if (!id || id === this._lastLoadedShortcut) return;
        this._lastLoadedShortcut = id;
        this._loading = true;
        try {
            const graphConfigs = await _dataservice.DataService.getInstance().getShortcut(id);
            if (graphConfigs && graphConfigs.length > 0) {
                const queries = [];
                const formulasPerQuery = [];
                for (const config of graphConfigs){
                    if (config.queries && config.queries.length > 0) {
                        for (const q of config.queries){
                            queries.push((0, _query.toParamSet)(q));
                            const pipeline = [];
                            if (config.formulas && config.formulas.length > 0) {
                                const f = config.formulas[0].trim();
                                const regex = /(ave|avg|sum|min|max|count|ratio|geo|norm|fill|log|step|iqrr|scale_by_ave|scale_by_avg|trace_ave|trace_avg|trace_cov|trace_stddev)\(/g;
                                let match;
                                while((match = regex.exec(f)) !== null){
                                    pipeline.unshift(this._normalizeFormulaName(match[1]));
                                }
                            }
                            formulasPerQuery.push(pipeline);
                        }
                    }
                }
                if (queries.length > 0) {
                    this._lastQueriesJson = JSON.stringify({
                        q: queries,
                        f: formulasPerQuery
                    });
                    this._formulasPerQuery = formulasPerQuery;
                    this.queries = queries;
                }
            }
        } catch (e) {
            console.error('Failed to load shortcut:', e);
        } finally{
            this._loading = false;
        }
    }
    _normalizeFormulaName(name) {
        switch(name){
            case 'avg':
                return 'ave';
            case 'trace_avg':
                return 'trace_ave';
            case 'scale_by_avg':
                return 'scale_by_ave';
            default:
                return name;
        }
    }
    async _updateShortcut() {
        if (window.perf && window.perf.disable_shortcut_update) {
            return;
        }
        const currentJson = JSON.stringify({
            q: this.queries,
            f: this._formulasPerQuery
        });
        if (currentJson === this._lastQueriesJson) {
            return;
        }
        this._lastQueriesJson = currentJson;
        const graphConfigs = this.queries.filter((q)=>Object.keys(q).length > 0).map((q, idx)=>{
            const config = new _graphconfig.GraphConfig();
            const qStr = (0, _query.fromParamSet)(q);
            config.queries = [
                qStr
            ];
            const pipeline = this._formulasPerQuery[idx] || [];
            if (pipeline.length > 0) {
                let expr = `filter("${qStr}")`;
                pipeline.forEach((step)=>{
                    expr = `${step}(${expr})`;
                });
                config.formulas = [
                    expr
                ];
            }
            return config;
        });
        if (graphConfigs.length === 0) {
            if (this._shortcut !== '') {
                this._shortcut = '';
                this._stateHasChanged();
            }
            return;
        }
        try {
            const id = await (0, _graphconfig.updateShortcut)(graphConfigs);
            if (id && id !== this._shortcut) {
                this._shortcut = id;
                this._stateHasChanged();
            }
        } catch (e) {
            console.error('Failed to update shortcut:', e);
        }
    }
    _mapAnomalyFields(anomaly) {
        return _object_spread_props(_object_spread({}, anomaly), {
            start_revision: anomaly.start_revision,
            end_revision: anomaly.end_revision,
            is_improvement: anomaly.is_improvement,
            bug_id: anomaly.bug_id,
            recovered: anomaly.recovered,
            status: anomaly.state,
            median_before: anomaly.median_before_anomaly,
            median_after: anomaly.median_after_anomaly,
            test_path: anomaly.test_path || anomaly.TestPath
        });
    }
    /**
   * Resolves and calculates the final begin and end Unix timestamps for data fetching.
   *
   * Calculations performed:
   * 1. Both begin & end provided (begin !== UNSET_TIME && end !== UNSET_TIME):
   *    - Uses them exactly as-is.
   * 2. Only begin provided (begin !== UNSET_TIME):
   *    - Calculates `end = begin + defaultRange`. If in future, caps at `now`.
   * 3. Only end provided (end !== UNSET_TIME):
   *    - Calculates `begin = end - defaultRange`.
   * 4. Neither provided (initial load):
   *    - Calculates `end = now` and `begin = now - defaultRange`.
   * 5. If both are equal (begin === end):
   *    - Centers range: `begin = begin - halfRange`, `end = end + halfRange`.
   *    - If `end` extends into the future, shifts the entire range backward so `end = now`.
   *
   * Side Effects:
   * - Instantly writes resolved default/partial timestamps back to `this._begin` and `this._end`
   *   so `stateReflector` serializes them directly to the browser URL on load.
   *
   * @returns Calculated begin and end timestamps.
   */ _resolveTimeRange() {
        var _window_perf, _this__defaults;
        let now = Math.floor(Date.now() / 1000);
        if ((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.demo) {
            // The demo dataset resides on March 22, 2020. Lock now anchor to April 1, 2020
            // so the standard 150-day lookback window correctly encompasses the historical files.
            now = Math.floor(new Date('2020-04-01T00:00:00Z').getTime() / 1000);
        }
        const defaultRangeS = ((_this__defaults = this._defaults) === null || _this__defaults === void 0 ? void 0 : _this__defaults.default_range) || 150 * 24 * 3600;
        let begin = this.begin;
        let end = this.end;
        const beginProvided = begin !== _const.UNSET_TIME;
        const endProvided = end !== _const.UNSET_TIME;
        if (beginProvided || endProvided) {
            if (!beginProvided) {
                begin = end - defaultRangeS;
            } else if (!endProvided) {
                end = begin + defaultRangeS;
                if (end > now) end = now;
            } else if (begin === end) {
                const halfRange = Math.floor(defaultRangeS / 2);
                begin = begin - halfRange;
                end = end + halfRange;
                if (end > now) {
                    const shift = end - now;
                    end = now;
                    begin -= shift;
                }
            }
        } else {
            begin = now - defaultRangeS;
            end = now;
        }
        const resolvedBegin = Math.round(begin);
        const resolvedEnd = Math.round(end);
        // Write back defaults/partials to keep the URL deterministic
        if (!beginProvided) {
            this.begin = resolvedBegin;
        }
        if (!endProvided) {
            this.end = resolvedEnd;
        }
        return {
            begin: resolvedBegin,
            end: resolvedEnd
        };
    }
    _getVisibleTraceIds() {
        const startIdx = this._tracePage * this.pageSize;
        const endIdx = startIdx + this.pageSize;
        return this._showAllTraces ? this._matchingTraceIds.slice(0, MAX_VISIBLE_TRACES) : this._matchingTraceIds.slice(startIdx, endIdx);
    }
    _getRequiredTraceIds(visibleIds) {
        const reqTraceIds = visibleIds.filter((id)=>{
            return this.queries.some((q, qIdx)=>{
                return !this._isQueryFormulaActive(qIdx) && this._traceMatchesQuery(id, q, this.queries.length);
            });
        });
        return Array.from(new Set(reqTraceIds));
    }
    _updateRegressionsFromResponse(anomalymap) {
        if (!anomalymap) return;
        const nextRegressions = _object_spread({}, this._regressions);
        for (const [traceId, commitMap] of Object.entries(anomalymap)){
            if (!commitMap) continue;
            if (!nextRegressions[traceId]) {
                nextRegressions[traceId] = {};
            }
            for (const [commit, anomaly] of Object.entries(commitMap)){
                nextRegressions[traceId][Number(commit)] = this._mapAnomalyFields(anomaly);
            }
        }
        this._regressions = nextRegressions;
    }
    async _fetchData(requestId, retryCount = 0) {
        console.log('[_fetchData] called, retryCount:', retryCount, 'requestId:', requestId);
        if (requestId !== this._latestRequestId) {
            console.log('[_fetchData] aborted early: request ID mismatch');
            return;
        }
        const visibleIds = this._getVisibleTraceIds();
        const activeFormulas = this._getActiveFormulas();
        if (visibleIds.length === 0 && activeFormulas.length === 0) {
            return;
        }
        const loadedIds = new Set(this._seriesData.map((s)=>s.id));
        this._loading = true;
        try {
            var _window_perf;
            const { begin, end } = this._resolveTimeRange();
            const quantizedNow = Math.floor(end / 3600) * 3600;
            let quantizedBegin = Math.floor(begin / 3600) * 3600;
            if (retryCount > 0) {
                const duration = (end - begin) * Math.pow(2, retryCount);
                quantizedBegin = quantizedNow - duration;
            }
            const reqTraceIds = this._getRequiredTraceIds(visibleIds);
            console.log('[_fetchData] reqTraceIds:', reqTraceIds, 'activeFormulas:', activeFormulas);
            if (activeFormulas.length === 0 && reqTraceIds.length > 0 && reqTraceIds.every((id)=>loadedIds.has(id))) {
                console.log('Skipping fetch: all requested traces already loaded in memory');
                if (requestId === this._latestRequestId) {
                    this._loading = false;
                }
                return;
            }
            const req = {
                begin: quantizedBegin,
                end: quantizedNow,
                trace_ids: reqTraceIds,
                formulas: activeFormulas.length > 0 ? activeFormulas : null,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            };
            const cacheKey = await (0, _db.hashRequest)(req, (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.fetch_anomalies_from_sql);
            const db = new _db.TraceDatabase();
            // TODO(b/381280000): Investigate if/how we can safely cache responses containing active formulas.
            const cached = activeFormulas.length === 0 ? await db.get(cacheKey) : null;
            if (requestId !== this._latestRequestId) return;
            if (cached) {
                console.log('Serving from cache:', cacheKey);
                this._updateRegressionsFromResponse(cached.anomalymap);
                if (cached.dataframe) {
                    const newSeries = this._translateDataFrame(cached.dataframe);
                    this._processNewSeries(newSeries, true);
                    void this._prefetchHistory(requestId);
                }
                return;
            }
            const response = await _dataservice.DataService.getInstance().sendFrameRequest(req, {
                onProgress: (prog)=>console.log('Progress:', prog),
                onMessage: (msg)=>console.error('Message:', msg)
            });
            if (requestId !== this._latestRequestId) {
                if (response && response.dataframe) {
                    await db.set(cacheKey, response);
                }
                return;
            }
            if (response) {
                this._updateRegressionsFromResponse(response.anomalymap);
            }
            if (response && response.dataframe) {
                const newSeries = this._translateDataFrame(response.dataframe);
                if (newSeries.length === 0 && retryCount < 6) {
                    console.log('Out of bounds empty traceset detected. Widening duration bounds retry:', retryCount + 1);
                    return await this._fetchData(requestId, retryCount + 1);
                }
                // If traceset is empty, render empty chart.
                this._processNewSeries(newSeries, true);
                void db.set(cacheKey, response).catch((err)=>console.warn('Cache set failed:', err));
                void this._prefetchHistory(requestId);
            }
        } catch (e) {
            console.error('Fetch error:', e);
        } finally{
            if (requestId === this._latestRequestId) {
                this._loading = false;
            }
        }
    }
    _getLoadedRowsRange() {
        let min = Infinity;
        let max = -Infinity;
        for (const s of this._seriesData){
            if (s.rows) {
                for (const r of s.rows){
                    if (r.createdat !== undefined && r.createdat > 0) {
                        if (r.createdat < min) min = r.createdat;
                        if (r.createdat > max) max = r.createdat;
                    }
                }
            }
        }
        if (min === Infinity || max === -Infinity) {
            return null;
        }
        return {
            min,
            max
        };
    }
    _getPrefetchBounds(end) {
        let prefetchBegin = end - this._summaryBeginOffsetSec;
        let prefetchEnd = end + this._summaryEndOffsetSec;
        const existingRange = this._getLoadedRowsRange();
        if (existingRange) {
            if (prefetchBegin > existingRange.min) {
                prefetchBegin = existingRange.min;
            }
            if (prefetchEnd < existingRange.max) {
                prefetchEnd = existingRange.max;
            }
        }
        return {
            begin: Math.floor(prefetchBegin / 3600) * 3600,
            end: Math.floor(prefetchEnd / 3600) * 3600
        };
    }
    async _prefetchHistory(requestId) {
        var _window_perf;
        console.log(`[_prefetchHistory] initiating background prefetch from -${this._summaryBeginOffsetSec}s to +${this._summaryEndOffsetSec}s`);
        if (this._prefetchAbortController) {
            this._prefetchAbortController.abort();
        }
        this._prefetchAbortController = new AbortController();
        const signal = this._prefetchAbortController.signal;
        const visibleIds = this._getVisibleTraceIds();
        if (visibleIds.length === 0) return;
        const { end } = this._resolveTimeRange();
        const bounds = this._getPrefetchBounds(end);
        const activeFormulas = this._getActiveFormulas();
        const reqTraceIds = this._getRequiredTraceIds(visibleIds);
        const req = {
            begin: bounds.begin,
            end: bounds.end,
            trace_ids: reqTraceIds,
            formulas: activeFormulas.length > 0 ? activeFormulas : null,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        const cacheKey = await (0, _db.hashRequest)(req, (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.fetch_anomalies_from_sql);
        const db = new _db.TraceDatabase();
        this._summaryLoading = true;
        try {
            const cached = await db.get(cacheKey);
            if (requestId !== this._latestRequestId) return;
            if (cached) {
                if (signal.aborted) return;
                console.log('Prefetch serving from cache:', cacheKey);
                if (cached.dataframe) {
                    const newSeries = this._translateDataFrame(cached.dataframe);
                    this._processNewSeries(newSeries, false);
                }
                return;
            }
            const response = await _dataservice.DataService.getInstance().sendFrameRequest(req, {
                onProgress: (prog)=>console.log('Prefetch Progress:', prog),
                onMessage: (msg)=>console.error('Prefetch Message:', msg)
            });
            if (response && response.dataframe) {
                void db.set(cacheKey, response).catch((err)=>console.warn('Prefetch cache set failed:', err));
            }
            if (requestId !== this._latestRequestId) {
                console.log('[_prefetchHistory] aborted (but cached): request ID mismatch');
                return;
            }
            if (signal.aborted) {
                console.log('Prefetch aborted');
                return;
            }
            if (response && response.dataframe) {
                const newSeries = this._translateDataFrame(response.dataframe);
                this._processNewSeries(newSeries, false);
            }
        } catch (e) {
            console.error('Prefetch error:', e);
        } finally{
            if (!signal.aborted && requestId === this._latestRequestId) {
                this._summaryLoading = false;
            }
        }
    }
    _handleToggleRegressions(e) {
        this.showRegressions = e.target.checked;
    }
    _getRegressionCommitBounds(reg, fallbackCommit) {
        var _reg_start_revision;
        const rawStart = (_reg_start_revision = reg.start_revision) !== null && _reg_start_revision !== void 0 ? _reg_start_revision : reg.prev_commit_number;
        const start = rawStart !== undefined && rawStart !== null ? Number(rawStart) : reg.commit_number !== undefined && reg.commit_number !== null ? Number(reg.commit_number) - 1 : fallbackCommit - 1;
        var _reg_end_revision, _ref;
        const end = (_ref = (_reg_end_revision = reg.end_revision) !== null && _reg_end_revision !== void 0 ? _reg_end_revision : reg.commit_number) !== null && _ref !== void 0 ? _ref : fallbackCommit;
        return {
            start: Number(start),
            end: Number(end)
        };
    }
    _getFilteredRegressions() {
        if (!this._regressions) {
            return [];
        }
        const hasHighlightFilter = Array.isArray(this.highlightAnomalies) && this.highlightAnomalies.length > 0;
        const result = [];
        for (const commitMap of Object.values(this._regressions)){
            if (!commitMap) continue;
            for (const [commitStr, reg] of Object.entries(commitMap)){
                if (!reg) continue;
                if (hasHighlightFilter && !this.highlightAnomalies.some((id)=>String(id) === String(reg.id || ''))) {
                    continue;
                }
                result.push({
                    reg,
                    commit: Number(commitStr)
                });
            }
        }
        return result;
    }
    /**
   * Calculates the viewport range [minCommit - PADDING, maxCommit + PADDING] covering all
   * (or highlighted) anomalies in _regressions.
   */ _getAnomalyViewportRange() {
        const regs = this._getFilteredRegressions();
        if (regs.length === 0) {
            return null;
        }
        let minCommit = Infinity;
        let maxCommit = -Infinity;
        for (const { reg, commit } of regs){
            const bounds = this._getRegressionCommitBounds(reg, commit);
            if (!isNaN(bounds.start) && bounds.start < minCommit) {
                minCommit = bounds.start;
            }
            if (!isNaN(bounds.end) && bounds.end > maxCommit) {
                maxCommit = bounds.end;
            }
        }
        if (minCommit === Infinity || maxCommit === -Infinity) {
            return null;
        }
        return {
            minCommit: Math.max(0, minCommit - ANOMALY_VIEWPORT_PADDING_COMMITS),
            maxCommit: maxCommit + ANOMALY_VIEWPORT_PADDING_COMMITS
        };
    }
    /**
   * Translates a commit number to the appropriate X-axis viewport coordinate
   * based on the active domain mode (commit number vs. timestamp).
   * Returns null if dateMode is true and timestamp translation fails.
   */ _toViewportX(commitNumber) {
        if (!this.dateMode) {
            return commitNumber;
        }
        const timestamp = this._translateCommitToTimestamp(commitNumber);
        return timestamp !== _const.UNSET_TIME ? timestamp : null;
    }
    _onResetZoomEmbedded() {
        const anomalyRange = this._getAnomalyViewportRange();
        if (anomalyRange) {
            const minX = this._toViewportX(anomalyRange.minCommit);
            const maxX = this._toViewportX(anomalyRange.maxCommit);
            if (minX !== null && maxX !== null) {
                this.viewportMinX = minX;
                this.viewportMaxX = maxX;
                return;
            }
        }
        if (this._initialViewportBounds) {
            this.viewportMinX = this._initialViewportBounds.minX;
            this.viewportMaxX = this._initialViewportBounds.maxX;
        } else {
            this.viewportMinX = null;
            this.viewportMaxX = null;
        }
    }
    _onResetZoom() {
        if (this.embedded) {
            this._onResetZoomEmbedded();
        } else {
            this.viewportMinX = null;
            this.viewportMaxX = null;
            this.begin = _const.UNSET_TIME;
            this.end = _const.UNSET_TIME;
            this._resolveTimeRange();
        }
        this._stateHasChanged();
        this.requestUpdate();
    }
    _determineYAxisTitle(traceNames) {
        if (traceNames.length < 1) {
            return '';
        }
        function parseVal(key, traceParams) {
            for (const kv of traceParams){
                if (kv.startsWith(key)) {
                    const pieces = kv.split('=', 2);
                    return pieces[1];
                }
            }
            return '';
        }
        let idx = 0;
        let params = traceNames[idx].split(',');
        let unit = parseVal('unit', params);
        let improvement_dir = parseVal('improvement_dir', params);
        for(idx = 1; idx < traceNames.length; idx++){
            params = traceNames[idx].split(',');
            if (unit !== parseVal('unit', params)) {
                unit = '';
            }
            if (improvement_dir !== parseVal('improvement_dir', params)) {
                improvement_dir = '';
            }
            if (unit === '' && improvement_dir === '') {
                return '';
            }
        }
        let title = '';
        if (unit !== '') {
            title += `${unit}`;
        }
        if (improvement_dir !== '') {
            if (unit !== '') {
                title += ' - ';
            }
            title += `${improvement_dir}`;
        }
        return title;
    }
    /**
   * Translates a commit number to its closest corresponding Unix timestamp (createdat)
   * using a high-performance Binary Search closest-match lookup on the sorted series data.
   * Reduces time complexity from O(N) to O(log N).
   *
   * @param commitNumber - The commit number to translate.
   * @returns The resolved Unix timestamp in epoch seconds, or -1 if series data is empty.
   */ _translateCommitToTimestamp(commitNumber) {
        if (!this._seriesData || this._seriesData.length === 0) {
            console.log('[_translateCommitToTimestamp] Series data is empty');
            return _const.UNSET_TIME;
        }
        // Find the series with the maximum number of rows (most complete history)
        let series = null;
        let maxRows = 0;
        for (const s of this._seriesData){
            if (s.rows && s.rows.length > maxRows) {
                maxRows = s.rows.length;
                series = s;
            }
        }
        if (!series) {
            console.log('[_translateCommitToTimestamp] No series with rows found');
            return _const.UNSET_TIME;
        }
        const rows = series.rows;
        if (this._evenXAxisSpacing) {
            if (commitNumber >= 0 && commitNumber < rows.length) {
                return rows[commitNumber].createdat;
            }
            return _const.UNSET_TIME;
        }
        let low = 0;
        let high = rows.length - 1;
        while(low < high){
            const mid = Math.floor((low + high) / 2);
            if (rows[mid].commit_number === commitNumber) {
                return rows[mid].createdat;
            }
            if (rows[mid].commit_number < commitNumber) {
                low = mid + 1;
            } else {
                high = mid;
            }
        }
        let closestIdx = low;
        if (low > 0) {
            const diff1 = Math.abs(rows[low].commit_number - commitNumber);
            const diff2 = Math.abs(rows[low - 1].commit_number - commitNumber);
            if (diff2 < diff1) {
                closestIdx = low - 1;
            }
        }
        return rows[closestIdx].createdat;
    }
    _handleViewportChanged(e) {
        const detail = e.detail;
        const { minCommit, maxCommit } = detail;
        if (minCommit === null || maxCommit === null) {
            this._onResetZoom();
            return;
        }
        // Update viewport instantly for visual sync
        this.viewportMinX = minCommit;
        this.viewportMaxX = maxCommit;
        if (this.dateMode) {
            this.begin = Math.floor(minCommit);
            this.end = Math.ceil(maxCommit);
            this._stateHasChanged();
        } else {
            const beginTime = this._translateCommitToTimestamp(Math.floor(minCommit));
            const endTime = this._translateCommitToTimestamp(Math.ceil(maxCommit));
            let changed = false;
            if (beginTime !== _const.UNSET_TIME && beginTime !== this.begin) {
                this.begin = beginTime;
                changed = true;
            }
            if (endTime !== _const.UNSET_TIME && endTime !== this.end) {
                this.end = endTime;
                changed = true;
            }
            if (changed) {
                this._stateHasChanged();
            }
        }
        if (this._viewportChangeTimeout) {
            clearTimeout(this._viewportChangeTimeout);
        }
        this._viewportChangeTimeout = setTimeout(()=>{
            this._doHandleViewportChanged(e).catch((err)=>{
                console.error('Failed to handle viewport change:', err);
            });
        }, 300);
    }
    _handleSummaryRangeSelected(e) {
        const { begin, end } = e.detail;
        if (this.viewportMinX === begin && this.viewportMaxX === end) {
            console.log('[_handleSummaryRangeSelected] Viewport matches exactly. Skipped.');
            return;
        }
        this.viewportMinX = begin;
        this.viewportMaxX = end;
        if (this.dateMode) {
            this.begin = Math.floor(begin);
            this.end = Math.ceil(end);
            console.log(`[_handleSummaryRangeSelected] DateMode true. New bounds: begin ${this.begin}, end ${this.end}`);
            this._stateHasChanged();
        } else {
            const beginTime = this._translateCommitToTimestamp(Math.floor(begin));
            const endTime = this._translateCommitToTimestamp(Math.ceil(end));
            let changed = false;
            if (beginTime !== _const.UNSET_TIME && beginTime !== this.begin) {
                this.begin = beginTime;
                changed = true;
            }
            if (endTime !== _const.UNSET_TIME && endTime !== this.end) {
                this.end = endTime;
                changed = true;
            }
            if (changed) {
                this._stateHasChanged();
            }
        }
    }
    _handleLoadMore(e) {
        const side = e.detail;
        if (side === 'left') {
            this._summaryBeginOffsetSec += SUMMARY_INCREMENT_SEC;
        } else {
            this._summaryEndOffsetSec += SUMMARY_INCREMENT_SEC;
        }
        void this._prefetchHistory(this._latestRequestId);
    }
    async _doHandleViewportChanged(e) {
        const detail = e.detail;
        const { minCommit, maxCommit } = detail;
        const startIdx = this._tracePage * this.pageSize;
        const endIdx = startIdx + this.pageSize;
        const visibleIds = this._matchingTraceIds.slice(startIdx, endIdx);
        const loadedIds = new Set(this._seriesData.map((s)=>s.id));
        const allVisibleIds = [
            ...visibleIds
        ];
        const requests = (0, _fetchlogic.calculateFetchRequests)(Array.from(new Set(allVisibleIds)), loadedIds, {
            min: minCommit,
            max: maxCommit
        }, this._loadedBounds, this._globalBounds, this._getPrimaryKey.bind(this), this.dateMode);
        console.log('[_doHandleViewportChanged] requests:', requests);
        for (const req of requests){
            try {
                var _window_perf;
                const fetchReq = {
                    ids: req.ids,
                    min_commit: 0,
                    max_commit: 0
                };
                if (this.dateMode) {
                    fetchReq.begin = Math.floor(req.min || 0);
                    fetchReq.end = Math.ceil(req.max || 0);
                } else {
                    fetchReq.min_commit = Math.floor(req.min || 0);
                    fetchReq.max_commit = Math.ceil(req.max || 0);
                }
                fetchReq.ids.sort();
                const cacheKey = await (0, _db.hashRequest)(fetchReq, (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.fetch_anomalies_from_sql);
                const db = new _db.TraceDatabase();
                const cached = await db.get(cacheKey);
                let resp;
                if (cached) {
                    console.log('Serving trace values from cache:', cacheKey);
                    resp = cached;
                } else {
                    resp = await _dataservice.DataService.getInstance().fetchTraceValues(fetchReq);
                    console.log('[_doHandleViewportChanged] fetchTraceValues response:', resp);
                    await db.set(cacheKey, resp);
                }
                if (resp && resp.anomalymap) {
                    const nextRegressions = _object_spread({}, this._regressions);
                    for (const [traceId, commitMap] of Object.entries(resp.anomalymap)){
                        if (!commitMap) continue;
                        const primaryKey = traceId;
                        if (!nextRegressions[primaryKey]) {
                            nextRegressions[primaryKey] = {};
                        }
                        for (const [commit, anomaly] of Object.entries(commitMap)){
                            nextRegressions[primaryKey][Number(commit)] = this._mapAnomalyFields(anomaly);
                        }
                    }
                    this._regressions = nextRegressions;
                }
                if (resp && resp.results) {
                    const convertedSeries = [];
                    for (const [id, rows] of Object.entries(resp.results)){
                        const primaryKey = id;
                        let s = convertedSeries.find((cs)=>cs.id === primaryKey);
                        if (!s) {
                            s = {
                                id: primaryKey,
                                rows: [],
                                color: '',
                                allStats: {}
                            };
                            convertedSeries.push(s);
                        }
                        s.originalId = id;
                        const mappedRows = rows.map((r)=>({
                                commit_number: r.commit_number,
                                createdat: r.createdat,
                                val: r.val,
                                smoothedVal: r.val
                            }));
                        s.rows = mappedRows;
                    }
                    this._mergeSeriesData(convertedSeries);
                    // If a left fetch returned no data for an ID, mark that we reached the global min.
                    if (req.order === 'DESC') {
                        req.ids.forEach((id)=>{
                            const rows = resp.results[id];
                            if (!rows || rows.length === 0) {
                                if (!this._globalBounds[id]) {
                                    this._globalBounds[id] = {
                                        min: Infinity,
                                        max: -Infinity
                                    };
                                }
                                const lBounds = this._loadedBounds[id];
                                if (lBounds) {
                                    this._globalBounds[id].min = lBounds.min;
                                }
                            }
                        });
                    }
                }
            } catch (error) {
                console.error('Failed to fetch trace values:', error);
            }
        }
    }
    _handleToggleTrace(id) {
        const nextSeriesData = this._seriesData.map((s)=>{
            if (s.id === id) {
                return _object_spread_props(_object_spread({}, s), {
                    hidden: !s.hidden
                });
            }
            return s;
        });
        this._updateSeriesData(nextSeriesData);
        this._updateLoadedBounds();
    }
    _handleCloseChart(ids) {
        const idSet = new Set(ids);
        this._updateSeriesData(this._seriesData.filter((s)=>!idSet.has(s.id)));
        this._updateLoadedBounds();
        ids.forEach((id)=>delete this._globalBounds[id]);
    }
    _mergeSeriesData(olderSeries) {
        const newSeries = [
            ...this._seriesData
        ];
        const map = new Map();
        newSeries.forEach((s)=>map.set(s.id, s));
        olderSeries.forEach((os)=>{
            const existing = map.get(os.id);
            if (existing) {
                if (os.originalId) {
                    existing.originalId = os.originalId;
                }
                // Merge rows
                const allRows = [
                    ...existing.rows,
                    ...os.rows
                ];
                const unique = new Map();
                allRows.forEach((r)=>unique.set(r.commit_number, r));
                existing.rows = Array.from(unique.values()).sort((a, b)=>a.commit_number - b.commit_number);
            } else {
                newSeries.push(os);
            }
        });
        this._updateSeriesData(newSeries);
        this._updateLoadedBounds();
    }
    _translateDataFrame(df) {
        if (!df || !df.traceset || !df.header) return [];
        const seriesMap = new Map();
        const keys = Object.keys(df.traceset);
        console.log('[_translateDataFrame] keys count:', keys.length);
        // Cap at MAX_VISIBLE_TRACES traces as requested
        const limitedKeys = keys.slice(0, MAX_VISIBLE_TRACES);
        limitedKeys.forEach((key)=>{
            const traceValues = df.traceset[key];
            const rows = [];
            df.header.forEach((header, hIdx)=>{
                const val = traceValues[hIdx];
                const isSentinel = Math.abs(val) > 1e20;
                if (header && val !== null && val !== undefined && !isNaN(val) && !isSentinel) {
                    rows.push({
                        commit_number: header.offset,
                        val: val,
                        createdat: header.timestamp,
                        hash: header.hash,
                        url: header.url,
                        author: header.author,
                        message: header.message
                    });
                }
            });
            const params = this._parseTraceKey(key);
            const stat = params['stat'];
            console.log('[_translateDataFrame] key:', key, 'stat:', stat);
            const isFormula = this._isFormulaKey(key);
            const primaryParams = _object_spread({}, params);
            let primaryKey = key.trim();
            if (!isFormula) {
                try {
                    primaryKey = (0, _paramtools.makeKey)(primaryParams);
                } catch (e) {
                    console.error('[_translateDataFrame] makeKey failed for', primaryParams, e);
                }
            }
            const s = seriesMap.get(primaryKey);
            if (!s) {
                const newSeries = {
                    id: primaryKey,
                    color: '',
                    rows: rows,
                    allStats: {},
                    originalId: key,
                    isFormula: isFormula
                };
                seriesMap.set(primaryKey, newSeries);
            }
        });
        console.log('[_translateDataFrame] seriesMap size:', seriesMap.size);
        const result = [];
        let idx = 0;
        seriesMap.forEach((s)=>{
            s.color = `hsl(${idx * 137.5 % 360}, 70%, 50%)`;
            idx++;
            result.push(s);
        });
        return result;
    }
    _isFormulaKey(key) {
        if (!key) return false;
        const trimmed = key.trim();
        return trimmed.startsWith('formula(') || trimmed.includes('filter(') || /^(ave|avg|sum|min|max|count|ratio|geo|norm|fill|log|step|iqrr|scale_by_ave|scale_by_avg|trace_ave|trace_avg|trace_cov|trace_stddev)\(/.test(trimmed);
    }
    _parseTraceKey(key) {
        if (this._isFormulaKey(key)) {
            return {
                formula: key.trim()
            };
        }
        const params = {};
        const parts = key.split(',');
        parts.forEach((part)=>{
            if (!part) return;
            const idx = part.indexOf('=');
            if (idx !== -1) {
                const k = part.substring(0, idx);
                const v = part.substring(idx + 1);
                params[k] = v;
            }
        });
        return params;
    }
    _getPrimaryKey(key) {
        return key;
    }
    async _toggleV2Mode() {
        const graphConfigs = this.queries.map((q)=>{
            const config = new _graphconfig.GraphConfig();
            config.queries = [
                (0, _query.fromParamSet)(q)
            ];
            return config;
        });
        const urlParams = new URLSearchParams();
        if (graphConfigs.length > 0) {
            const shortcutId = await (0, _graphconfig.updateShortcut)(graphConfigs);
            if (shortcutId) {
                urlParams.set('shortcut', shortcutId);
            }
        }
        if (this.splitKeys.size > 0) {
            urlParams.set('splitByKeys', Array.from(this.splitKeys).join(','));
        }
        if (this.dateMode) {
            urlParams.set('dateAxis', 'true');
        }
        if (this.begin && this.begin !== _const.UNSET_TIME) {
            urlParams.set('begin', this.begin.toString());
        }
        if (this.end && this.end !== _const.UNSET_TIME) {
            urlParams.set('end', this.end.toString());
        }
        if (window.perf && window.perf.default_to_manual_plot_mode) {
            urlParams.set('manual_plot_mode', 'true');
        }
        const nextSearch = urlParams.toString();
        localStorage.setItem('perf:use-explore-v2', 'false');
        this.redirect(`/m${nextSearch ? `?${nextSearch}` : ''}`);
    }
    // Visible for testing
    redirect(url) {
        window.location.href = url;
    }
    _mergeSeriesWithStats(existing, newSeries) {
        const existingMap = new Map(existing.map((s)=>[
                s.id,
                s
            ]));
        newSeries.forEach((s)=>{
            const existingSeries = existingMap.get(s.id);
            if (existingSeries) {
                if (s.originalId) {
                    existingSeries.originalId = s.originalId;
                }
                if (s.rows && s.rows.length > 0) {
                    existingSeries.rows = s.rows;
                }
                if (s.allStats) {
                    existingSeries.allStats = _object_spread({}, existingSeries.allStats, s.allStats);
                }
            } else {
                existingMap.set(s.id, s);
            }
        });
        return Array.from(existingMap.values());
    }
    _shouldKeepSeries(s) {
        return !this.queries.some((q, qIdx)=>{
            return this._isQueryFormulaActive(qIdx) && this._traceMatchesQuery(s.id, q, this.queries.length);
        });
    }
    /**
   * Merges new series into state, calculates loaded bounds, and initializes
   * viewport bounds if they are currently unset.
   */ _processNewSeries(newSeries, updateViewport = true) {
        const baseSeries = this._seriesData.filter((s)=>this._shouldKeepSeries(s));
        this._updateSeriesData(this._mergeSeriesWithStats(baseSeries, newSeries));
        this._updateLoadedBounds();
        if (updateViewport && (this.viewportMinX === null || this.viewportMaxX === null)) {
            const visibleSeries = this._seriesData.filter((s)=>!s.hidden);
            const sharedBounds = (0, _chartlogic.calculateSharedBounds)(visibleSeries, this._globalBounds, this.dateMode);
            if (sharedBounds) {
                const source = Object.keys(sharedBounds)[0];
                this.viewportMinX = sharedBounds[source].min;
                this.viewportMaxX = sharedBounds[source].max;
            }
        }
    }
    _updateSeriesData(series) {
        this._seriesData = series.map((s, idx)=>_object_spread_props(_object_spread({}, s), {
                color: `hsl(${idx * 137.5 % 360}, 70%, 50%)`
            }));
    }
    _updateLoadedBounds() {
        const visibleSeries = this._seriesData.filter((s)=>!s.hidden);
        this._loadedBounds = (0, _chartlogic.calculateLoadedBounds)(visibleSeries, this.dateMode);
    }
    _handleHoverChanged(e) {
        this._globalHoverX = e.detail.dataX;
    }
    _handlePinPoint(e) {
        this._globalPinnedX = e.detail.dataX;
    }
    _updateRegressionsState(regressions, traceNames) {
        const nextRegressions = _object_spread({}, this._regressions);
        regressions.forEach((reg, index)=>{
            var _reg;
            if (!((_reg = reg) === null || _reg === void 0 ? void 0 : _reg.id)) return;
            // Use traceNames[0] as fallback when a single trace name is passed for multiple anomalies.
            const traceName = traceNames[index] || traceNames[0];
            if (!traceName) return;
            const commitMap = _object_spread({}, nextRegressions[traceName] || {});
            this._removeExistingAnomaly(commitMap, reg.id);
            const newCommit = reg.display_commit_number || reg.end_revision;
            if (newCommit) {
                commitMap[newCommit] = this._mapAnomalyFields(reg);
            }
            nextRegressions[traceName] = commitMap;
        });
        this._regressions = nextRegressions;
    }
    _removeExistingAnomaly(commitMap, anomalyId) {
        for (const [commitStr, existing] of Object.entries(commitMap)){
            if (existing && String(existing.id) === String(anomalyId)) {
                delete commitMap[Number(commitStr)];
                break;
            }
        }
    }
    _onStartTour() {
        this._tourActive = true;
    }
    _handleTourStepChanged(e) {
        const idx = e.detail.index;
        switch(idx){
            case 0:
                this._onApplyComparisonPreset();
                break;
            case 1:
                const queryBar = this.shadowRoot.querySelector('query-bar-sk');
                if (queryBar) {
                    const textField = queryBar.shadowRoot.querySelector('.query-input');
                    if (textField) {
                        textField.dispatchEvent(new Event('focus'));
                        textField.value = 'test';
                        textField.dispatchEvent(new Event('input', {
                            bubbles: true
                        }));
                    }
                }
                break;
            case 2:
                const queryBarForSug = this.shadowRoot.querySelector('query-bar-sk');
                if (queryBarForSug) {
                    const textField = queryBarForSug.shadowRoot.querySelector('.query-input');
                    if (textField) {
                        textField.dispatchEvent(new Event('focus'));
                        textField.dispatchEvent(new Event('input', {
                            bubbles: true
                        }));
                    }
                }
                break;
            case 3:
                const qb = this.shadowRoot.querySelector('query-bar-sk');
                if (qb) {
                    const chip = qb.shadowRoot.querySelector('explore-multi-v2-select-sk');
                    if (chip) {
                        const trigger = chip.shadowRoot.querySelector('.multiselect-trigger');
                        if (trigger) {
                            trigger.click();
                        }
                    }
                }
                break;
            case 4:
                const qb2 = this.shadowRoot.querySelector('query-bar-sk');
                if (qb2) {
                    const chip = qb2.shadowRoot.querySelector('explore-multi-v2-select-sk');
                    if (chip) {
                        const trigger = chip.shadowRoot.querySelector('.multiselect-trigger');
                        if (trigger) {
                            trigger.click();
                        }
                    }
                }
                break;
            case 6:
                this._handleSplit(new CustomEvent('split', {
                    detail: {
                        key: 'bot'
                    }
                }));
                break;
            case 7:
                this.dateMode = !this.dateMode;
                this._stateHasChanged();
                break;
            case 8:
                this._smooth = true;
                this._hoverMode = 'both';
                this._smoothingRadius = 50;
                this.requestUpdate();
                break;
            case 10:
                if (this._seriesData.length > 0 && this._seriesData[0].rows.length > 0) {
                    this._globalHoverX = this._seriesData[0].rows[0].commit_number;
                }
                this.requestUpdate();
                break;
        }
    }
    _onApplyRandomPreset() {
        if (!this._workerController) return;
        this._workerController.getRandomTrace((randomQuery)=>{
            if (randomQuery) {
                this.queries = [
                    randomQuery
                ];
            }
        });
    }
    _onApplyComparisonPreset() {
        if (!this._workerController) return;
        this._workerController.getRandomTrace((randomQuery)=>{
            if (!randomQuery) return;
            const keys = Object.keys(randomQuery);
            if (keys.length === 0) return;
            // Start from the last key (the most specific parameter from our greedy builder)
            let chosenKey = keys[keys.length - 1];
            let opts = this._optionsByKey[chosenKey] || [];
            // Search backwards to find the most specific parameter that has multiple options to compare
            if (opts.length < 2) {
                for(let i = keys.length - 2; i >= 0; i--){
                    const key = keys[i];
                    const options = this._optionsByKey[key] || [];
                    if (options.length >= 2) {
                        chosenKey = key;
                        opts = options;
                        break;
                    }
                }
            }
            // Fall back to a single trace if no parameter can be compared
            if (opts.length < 2) {
                this.queries = [
                    randomQuery
                ];
                return;
            }
            const val1 = randomQuery[chosenKey][0];
            const otherOpts = opts.filter((o)=>o.value !== val1);
            if (otherOpts.length === 0) {
                this.queries = [
                    randomQuery
                ];
                return;
            }
            const val2 = otherOpts[Math.floor(Math.random() * otherOpts.length)].value;
            this.queries = [
                _object_spread_props(_object_spread({}, randomQuery), {
                    [chosenKey]: [
                        val1
                    ]
                }),
                _object_spread_props(_object_spread({}, randomQuery), {
                    [chosenKey]: [
                        val2
                    ]
                })
            ];
        });
    }
    _onAddQuery() {
        this.queries = [
            ...this.queries,
            _object_spread({}, this._defaultParamSelections)
        ];
        this._formulasPerQuery = [
            ...this._formulasPerQuery,
            []
        ];
        this._userToggledExpanded = true;
        this._queriesExpanded = true;
    }
    _toggleQueriesExpand() {
        this._userToggledExpanded = true;
        this._queriesExpanded = !this._queriesExpanded;
    }
    _clearSuggestions(idx) {
        const newSuggestions = [
            ...this._suggestionsForQueryBar
        ];
        newSuggestions[idx] = [];
        this._suggestionsForQueryBar = newSuggestions;
    }
    _onRemoveQueryBar(idx) {
        if (this.queries.length > 1) {
            this.queries = this.queries.filter((_, i)=>i !== idx);
            this._formulasPerQuery = this._formulasPerQuery.filter((_, i)=>i !== idx);
            this._suggestionsForQueryBar = this._suggestionsForQueryBar.filter((_, i)=>i !== idx);
        }
    }
    _onCloneQueryBar(idx) {
        const queryToClone = this.queries[idx];
        const clonedQuery = {};
        for (const [k, v] of Object.entries(queryToClone)){
            clonedQuery[k] = [
                ...v
            ];
        }
        const newQueries = [
            ...this.queries
        ];
        newQueries.splice(idx + 1, 0, clonedQuery);
        this.queries = newQueries;
        const newFormulas = [
            ...this._formulasPerQuery
        ];
        newFormulas.splice(idx + 1, 0, [
            ...this._formulasPerQuery[idx] || []
        ]);
        this._formulasPerQuery = newFormulas;
        const newSuggestions = [
            ...this._suggestionsForQueryBar
        ];
        newSuggestions.splice(idx + 1, 0, []);
        this._suggestionsForQueryBar = newSuggestions;
        this._userToggledExpanded = true;
        this._queriesExpanded = true;
    }
    _handleSuggest(idx, e) {
        var _this__workerController;
        const queryInput = e.detail.query;
        const currentQuery = this.queries[idx] || {};
        const availableParams = this._availableParamsPerQuery[idx] && this._availableParamsPerQuery[idx].length > 0 ? this._availableParamsPerQuery[idx] : this._globalAvailableParams.length > 0 ? this._globalAvailableParams : this._availableParams;
        const reqId = ((_this__workerController = this._workerController) === null || _this__workerController === void 0 ? void 0 : _this__workerController.suggest(queryInput, currentQuery, idx, availableParams, this._includeParams)) || 0;
        this._latestSuggestRequestIds[idx] = reqId;
    }
    _applyConditionalDefaults(query, changedKey, newValues, oldValues) {
        if (!this._conditionalDefaults) {
            return query;
        }
        let nextQuery = null;
        for (const rule of this._conditionalDefaults){
            if (rule.trigger.param === changedKey) {
                const hasNewTrigger = rule.trigger.values.some((v)=>newValues.includes(v) && !oldValues.includes(v));
                if (hasNewTrigger) {
                    if (!nextQuery) {
                        nextQuery = _object_spread({}, query);
                    }
                    for (const apply of rule.apply){
                        let newValuesToApply = [
                            ...apply.values
                        ];
                        if (apply.select_only_first && newValuesToApply.length > 0) {
                            newValuesToApply = [
                                newValuesToApply[0]
                            ];
                        }
                        nextQuery[apply.param] = newValuesToApply;
                    }
                }
            }
        }
        return nextQuery || query;
    }
    _handleAddQuery(idx, e) {
        const { key, value } = e.detail;
        const queries = [
            ...this.queries
        ];
        const current = queries[idx][key] || [];
        if (!current.includes(value)) {
            const newValues = [
                ...current,
                value
            ];
            queries[idx] = _object_spread_props(_object_spread({}, queries[idx]), {
                [key]: newValues
            });
            queries[idx] = this._applyConditionalDefaults(queries[idx], key, newValues, current);
            this.queries = queries;
        }
        this._clearSuggestions(idx);
    }
    _handleRemoveQuery(idx, e) {
        const { key, value } = e.detail;
        const queries = [
            ...this.queries
        ];
        const current = queries[idx][key] || [];
        const updated = current.filter((v)=>v !== value);
        if (updated.length === 0) {
            const nextQuery = _object_spread({}, queries[idx]);
            delete nextQuery[key];
            queries[idx] = nextQuery;
        } else {
            queries[idx] = _object_spread_props(_object_spread({}, queries[idx]), {
                [key]: updated
            });
        }
        this.queries = queries;
        this._clearSuggestions(idx);
    }
    _handleSetSelected(idx, e) {
        const { key, values } = e.detail;
        const queries = [
            ...this.queries
        ];
        const oldValues = queries[idx][key] || [];
        queries[idx] = _object_spread_props(_object_spread({}, queries[idx]), {
            [key]: values
        });
        queries[idx] = this._applyConditionalDefaults(queries[idx], key, values, oldValues);
        this.queries = queries;
        this._clearSuggestions(idx);
    }
    _handleRemoveKey(idx, e) {
        if (!e.detail) {
            const queries = [
                ...this.queries
            ];
            queries[idx] = {};
            this.queries = queries;
            this._clearSuggestions(idx);
            return;
        }
        const { key } = e.detail;
        const queries = [
            ...this.queries
        ];
        const nextQuery = _object_spread({}, queries[idx]);
        delete nextQuery[key];
        queries[idx] = nextQuery;
        this.queries = queries;
        this._clearSuggestions(idx);
    }
    _handleSplit(e) {
        const { key } = e.detail;
        const nextSplit = new Set(this.splitKeys);
        if (nextSplit.has(key)) {
            nextSplit.delete(key);
        } else {
            nextSplit.add(key);
        }
        this.splitKeys = nextSplit;
    }
    _handleReorderSplitKeys(e) {
        this.splitKeys = new Set(e.detail.keys);
    }
    _traceMatchesQuery(id, q, totalQueries = 1) {
        // If there is only one query bar, all traces currently displayed must belong
        // to it. Returning true here allows us to quickly clear all traces when the
        // query or its pipeline changes, without performing key matching.
        if (totalQueries === 1) return true;
        if (!q || Object.keys(q).length === 0) return false;
        const parts = id.split(',').filter(Boolean);
        return Object.entries(q).every(([k, vals])=>{
            if (!vals || vals.length === 0) return true;
            return vals.some((v)=>parts.includes(`${k}=${v}`));
        });
    }
    _isQueryFormulaActive(qIdx) {
        const pipeline = this._formulasPerQuery[qIdx] || [];
        return pipeline.length > 0;
    }
    _getActiveFormulas() {
        const formulas = [];
        this.queries.forEach((q, idx)=>{
            const pipeline = this._formulasPerQuery[idx] || [];
            if (pipeline.length > 0 && Object.keys(q).length > 0) {
                const qStr = (0, _query.fromParamSet)(q);
                if (qStr) {
                    let expr = `filter("${qStr}")`;
                    pipeline.forEach((step)=>{
                        expr = `${step}(${expr})`;
                    });
                    formulas.push(expr);
                }
            }
        });
        return formulas;
    }
    _isFormulaMatchingQuery(formulaId, q) {
        const qStr = (0, _query.fromParamSet)(q);
        if (!qStr) return false;
        return formulaId.includes(`filter("${qStr}")`) || formulaId.includes(`filter('${qStr}')`);
    }
    _handlePipelineChange(idx, e) {
        const formulas = [
            ...this._formulasPerQuery
        ];
        formulas[idx] = e.detail.pipeline;
        this._formulasPerQuery = formulas;
        this._seriesData = this._seriesData.filter((s)=>{
            if (this._isFormulaKey(s.id)) {
                return !this._isFormulaMatchingQuery(s.id, this.queries[idx]);
            }
            return !this._traceMatchesQuery(s.id, this.queries[idx], this.queries.length);
        });
        this._stateHasChanged();
        void this._fetchData(this._latestRequestId);
    }
    _handleFormulaChange(idx, e) {
        const formula = e.detail.formula;
        const pipeline = formula && formula !== 'none' ? [
            formula
        ] : [];
        this._handlePipelineChange(idx, new CustomEvent('pipeline-change', {
            detail: {
                pipeline
            }
        }));
    }
    _handleDiffBase(e) {
        const { key, value } = e.detail;
        console.log('[_handleDiffBase] Received event. key:', key, 'value:', value);
        if (this._diffBase && this._diffBase.key === key && this._diffBase.value === value) {
            console.log('[_handleDiffBase] Clearing diffBase');
            this._diffBase = null;
        } else {
            console.log('[_handleDiffBase] Setting diffBase to:', {
                key,
                value
            });
            this._diffBase = {
                key,
                value
            };
        }
    }
    async _fetchMetadataForVisibleTraces(requestId) {
        if (requestId !== this._latestRequestId) return;
        if (!this._seriesData || this._seriesData.length === 0) return;
        const startIdx = this._tracePage * this.pageSize;
        const endIdx = startIdx + this.pageSize;
        const currentVisibleIds = new Set(this._matchingTraceIds.slice(startIdx, endIdx).map((id)=>this._getPrimaryKey(id)));
        const visibleSeries = this._seriesData.filter((s)=>currentVisibleIds.has(s.id));
        if (visibleSeries.length === 0) return;
        const traceIdToOriginalId = new Map();
        const traceIds = visibleSeries.map((s)=>{
            const tId = s.originalId || s.id;
            traceIdToOriginalId.set(s.id, tId);
            return tId;
        });
        const commitNumbersSet = new Set();
        visibleSeries.forEach((s)=>{
            s.rows.forEach((r)=>{
                if (r.metadata === undefined && !this._inFlightMetadataCommits.has(r.commit_number)) {
                    commitNumbersSet.add(r.commit_number);
                }
            });
        });
        const commitNumbers = Array.from(commitNumbersSet);
        if (commitNumbers.length === 0) {
            return;
        }
        commitNumbers.forEach((c)=>this._inFlightMetadataCommits.add(c));
        try {
            console.log(`Fetching metadata for ${traceIds.length} traces and ${commitNumbers.length} commits.`);
            const db = new _db.TraceDatabase();
            const cacheKey = await (0, _db.hashRequest)({
                commitNumbers,
                traceIds
            });
            const cached = await db.get(cacheKey);
            if (requestId !== this._latestRequestId) return;
            let metadataResp;
            if (cached) {
                console.log('Serving metadata from cache:', cacheKey);
                metadataResp = cached;
            } else {
                metadataResp = await _dataservice.DataService.getInstance().getLinksBatch(commitNumbers, traceIds);
                if (requestId !== this._latestRequestId) return;
                await db.set(cacheKey, metadataResp);
            }
            if (requestId !== this._latestRequestId) return;
            const nextSeriesData = [
                ...this._seriesData
            ];
            let updatedCount = 0;
            nextSeriesData.forEach((s, idx)=>{
                if (currentVisibleIds.has(s.id)) {
                    const nextRows = [
                        ...s.rows
                    ];
                    let rowChanged = false;
                    const requestedId = traceIdToOriginalId.get(s.id) || s.id;
                    nextRows.forEach((r, rowIdx)=>{
                        if (commitNumbersSet.has(r.commit_number) && r.metadata === undefined) {
                            var _metadataResp;
                            const commitMetadataMap = ((_metadataResp = metadataResp) === null || _metadataResp === void 0 ? void 0 : _metadataResp[r.commit_number.toString()]) || {};
                            let commitMetadata = null;
                            for (const [respTraceId, links] of Object.entries(commitMetadataMap)){
                                if (this._getPrimaryKey(respTraceId) === this._getPrimaryKey(requestedId) || this._getPrimaryKey(respTraceId) === this._getPrimaryKey(s.id) || this._getPrimaryKey(respTraceId) === this._getPrimaryKey(s.originalId || '')) {
                                    commitMetadata = links;
                                    break;
                                }
                            }
                            if (!commitMetadata) {
                                commitMetadata = commitMetadataMap[requestedId] || commitMetadataMap[s.id] || commitMetadataMap[s.originalId || ''] || null;
                            }
                            nextRows[rowIdx] = _object_spread_props(_object_spread({}, r), {
                                metadata: commitMetadata
                            });
                            rowChanged = true;
                            updatedCount++;
                        }
                    });
                    if (rowChanged) {
                        nextSeriesData[idx] = _object_spread_props(_object_spread({}, s), {
                            rows: nextRows
                        });
                    }
                }
            });
            if (updatedCount > 0) {
                console.log(`Successfully fetched and attached metadata to ${updatedCount} trace rows.`);
                this._updateSeriesData(nextSeriesData);
                this._updateAvailableSubrepos();
            }
            // Clear in-flight requests since they are either fulfilled or marked as null
            commitNumbers.forEach((c)=>this._inFlightMetadataCommits.delete(c));
        } catch (e) {
            console.error('Failed to fetch metadata:', e);
            // On failure, remove from in-flight so we can retry later
            commitNumbers.forEach((c)=>this._inFlightMetadataCommits.delete(c));
        }
    }
    _updateAvailableSubrepos() {
        const keys = new Set();
        this._seriesData.forEach((s)=>{
            s.rows.forEach((r)=>{
                if (r.metadata) {
                    Object.keys(r.metadata).forEach((k)=>{
                        if (SUBREPO_CONFIG[k]) {
                            keys.add(k);
                        }
                    });
                }
            });
        });
        this._availableSubrepos = Array.from(keys).sort();
    }
    _handleControlChange(e) {
        const { name, value } = e.detail;
        if (name in this) {
            this[name] = value;
        } else {
            this[`_${name}`] = value;
        }
        // Handle side effects
        if (name === 'dateMode') {
            this._globalBounds = {};
            this._updateLoadedBounds();
            this.viewportMinX = null;
            this.viewportMaxX = null;
        } else if (name === 'smooth') {
            this._hoverMode = value ? 'both' : 'original';
        }
    }
    get _availableSplitKeys() {
        const allKeys = Object.keys(this._optionsByKey);
        return allKeys.filter((k)=>!this._includeParams.includes(k));
    }
    render() {
        let displaySeries = this._diffBase ? (0, _chartlogic.computeTraceDiffs)(this._seriesData, this._diffBase) : this._seriesData;
        if (this._transformPreset !== 'none') {
            displaySeries = (0, _chartlogic.computeCustomTransforms)(displaySeries, this._transformPreset);
        }
        const totalMatchedPages = Math.max(1, Math.ceil(this._matchingTraceIds.length / this.pageSize));
        const clampedPage = Math.max(0, Math.min(this._tracePage, totalMatchedPages - 1));
        const startIdx = clampedPage * this.pageSize;
        const endIdx = startIdx + this.pageSize;
        const currentVisibleIds = this._showAllTraces ? new Set(this._matchingTraceIds.slice(0, MAX_VISIBLE_TRACES).map((id)=>this._getPrimaryKey(id))) : new Set(this._matchingTraceIds.slice(startIdx, endIdx).map((id)=>this._getPrimaryKey(id)));
        const regressionTraceIds = new Set(Object.keys(this._regressions || {}));
        const currentPageTraces = displaySeries.filter((s)=>{
            if (s.isFormula || this._isFormulaKey(s.id)) {
                return true;
            }
            // Note: We cannot simply use `(s as any).originalId || s.id`.
            // For original series, `s.id` is the collapsed primary key (e.g. without `stat=min/max`),
            // while `s.originalId` is the un-collapsed raw database key (containing `stat=`).
            // Since `currentVisibleIds` only contains collapsed primary keys, using `originalId` on
            // original traces would check for un-collapsed keys and discard all traces from the graph.
            // Therefore, we only fallback to `originalId` if the series is a transformed series.
            const primaryKey = s.id.includes('special=transform') ? s.originalId : s.id;
            if (!currentVisibleIds.has(primaryKey)) {
                return false;
            }
            if (this.onlyRegressions) {
                const regKeys = [
                    s.originalId,
                    s.id,
                    primaryKey
                ].filter(Boolean);
                return regKeys.some((k)=>regressionTraceIds.has(k) && Object.keys(this._regressions[k] || {}).length > 0);
            }
            return true;
        });
        const groups = (0, _chartlogic.computeSplitGroups)(currentPageTraces, this.splitKeys, this.splitAll);
        return (0, _lit.html)`
      ${this.embedded ? '' : (0, _lit.html)`
            <div class="header">
              <div>
                <h1>Explore Multi V2</h1>
                <p class="subtitle">
                  High-performance custom dimension analysis (Work in Progress)
                </p>
              </div>
              <div
                class="v2-toggle-container"
                style="display: inline-flex; align-items: center; gap: 12px; border-radius: 8px; padding: 8px 16px; border: 1px solid var(--outline, rgba(255,255,255,0.1)); background-color: rgba(128,128,128,0.05);">
                <span
                  style="font-size: 12px; font-weight: 600; color: var(--on-background, #cbd5e1);"
                  >Explore Multi V2:</span
                >
                <button
                  @click=${this._toggleV2Mode}
                  style="background: var(--primary); color: var(--on-primary); border: none; padding: 4px 16px; border-radius: 12px; font-size: 11px; font-weight: bold; cursor: pointer; transition: all 0.2s;">
                  ACTIVE (Switch to Legacy)
                </button>
              </div>
            </div>
          `}

      <div class="workspace">
        <div class="section-title">Faceted Search Bar</div>
        ${this.queries.map((q, idx)=>{
            if (!this._queriesExpanded) {
                return '';
            }
            return (0, _lit.html)`
            <div class="query-row" style="display: flex; align-items: center; gap: 8px;">
              <query-bar-sk
                style="flex: 1;"
                .query=${q}
                .availableParams=${this._availableParamsPerQuery[idx] && this._availableParamsPerQuery[idx].length > 0 ? this._availableParamsPerQuery[idx] : this._globalAvailableParams.length > 0 ? this._globalAvailableParams : this._availableParams}
                .optionsByKey=${this._optionsByKeyPerQuery[idx] && Object.keys(this._optionsByKeyPerQuery[idx]).length > 0 ? this._optionsByKeyPerQuery[idx] : Object.keys(this._globalOptionsByKey).length > 0 ? this._globalOptionsByKey : this._optionsByKey}
                .splitKeys=${this.splitKeys}
                .includeParams=${this._includeParams}
                .defaults=${this._defaults}
                .showRemoveQueryButton=${this.queries.length > 1}
                .formula=${this._formulasPerQuery[idx] && this._formulasPerQuery[idx][this._formulasPerQuery[idx].length - 1] || 'none'}
                .pipeline=${this._formulasPerQuery[idx] || []}
                @pipeline-change=${(e)=>this._handlePipelineChange(idx, e)}
                .onlyRegressions=${this.onlyRegressions}
                .splitAll=${this.splitAll}
                .externalSuggestions=${this._suggestionsForQueryBar[idx] || null}
                .loading=${this._isCalculatingCounts}
                @suggest=${(e)=>this._handleSuggest(idx, e)}
                @add-query=${(e)=>this._handleAddQuery(idx, e)}
                @remove-query=${(e)=>this._handleRemoveQuery(idx, e)}
                @set-selected=${(e)=>this._handleSetSelected(idx, e)}
                @remove-key=${(e)=>this._handleRemoveKey(idx, e)}
                @split=${(e)=>this._handleSplit(e)}
                @diff-base=${(e)=>this._handleDiffBase(e)}
                @formula-change=${(e)=>this._handleFormulaChange(idx, e)}
                @toggle-only-regressions=${()=>{
                this.onlyRegressions = !this.onlyRegressions;
            }}
                @toggle-split-all=${()=>{
                this.splitAll = !this.splitAll;
            }}
                @clear-query=${()=>this._onRemoveQueryBar(idx)}
                @clone-query=${()=>this._onCloneQueryBar(idx)}></query-bar-sk>
            </div>
          `;
        })}
        <div
          style="display: flex; justify-content: center; align-items: center; gap: 8px; margin-top: -6px; position: relative; z-index: 1;">
          <button class="add-query-circle-btn" @click=${this._onAddQuery} title="Add Query">
            +
          </button>
          ${this.queries.length > 0 ? (0, _lit.html)`
                <button
                  class="expand-queries-btn"
                  @click=${this._toggleQueriesExpand}
                  title="${this._queriesExpanded ? 'Hide all search bars' : 'Show all search bars'}">
                  ${this._queriesExpanded ? 'Collapse' : 'Expand'}
                </button>
              ` : ''}
        </div>

        ${this._diffBase || this.splitKeys.size > 0 ? (0, _lit.html)`
              <div class="config-pills">
                ${Array.from(this.splitKeys).map((key)=>(0, _lit.html)`
                    <div class="config-pill">
                      <span class="config-pill-label">Split by:</span>
                      <span>${key}</span>
                      <button
                        class="config-pill-remove"
                        @click=${()=>this._handleSplit(new CustomEvent('split', {
                    detail: {
                        key
                    }
                }))}>
                        &times;
                      </button>
                    </div>
                  `)}
                ${this._diffBase ? (0, _lit.html)`
                      <div class="config-pill diff-base">
                        <span class="config-pill-label">Diff Base:</span>
                        <span
                          class="config-pill-value"
                          title=${`${this._diffBase.key}=${this._diffBase.value}`}>
                          ${this._diffBase.value}
                        </span>
                        <button
                          class="config-pill-remove"
                          @click=${()=>this._handleDiffBase(new CustomEvent('diff-base', {
                detail: {
                    key: this._diffBase.key,
                    value: this._diffBase.value
                }
            }))}>
                          &times;
                        </button>
                      </div>
                    ` : ''}
              </div>
            ` : ''}

        <explore-toolbar-sk
          .openAdvanced=${!this.embedded}
          .tracePage=${this._tracePage}
          .totalMatchedPages=${totalMatchedPages}
          .showAllTraces=${this._showAllTraces}
          .selectedSubrepo=${this._selectedSubrepo}
          .availableSubrepos=${this._availableSubrepos}
          .normalizeCentre=${this._normalizeCentre}
          .smooth=${this._smooth}
          .showDots=${this._showDots}
          .showSparklines=${this.showSparklines}
          .onlyRegressions=${this.onlyRegressions}
          .splitAll=${this.splitAll}
          .evenXAxisSpacing=${this._evenXAxisSpacing}
          .showZero=${this._showZero}
          .transformPreset=${this._transformPreset}
          .showRegressions=${this.showRegressions}
          .tooltipDiffs=${this._tooltipDiffs}
          .dateMode=${this.dateMode}
          .hoverMode=${this._hoverMode}
          .smoothingRadius=${this._smoothingRadius}
          .edgeDetectionFactor=${this._edgeDetectionFactor}
          .edgeLookahead=${this._edgeLookahead}
          .availableSplitKeys=${this._availableSplitKeys}
          .activeSplitKeys=${Array.from(this.splitKeys)}
          .pageSize=${this.pageSize}
          @control-change=${this._handleControlChange}
          @split=${this._handleSplit}
          @reset-zoom=${this._onResetZoom}></explore-toolbar-sk>

        <div class="section-title">Visualizations</div>

        ${this._loading && groups.length === 0 ? (0, _lit.html)`
              <div class="page-loading">
                <div class="spinner"></div>
                <span>${this._statusMessage || 'Loading traces...'}</span>
              </div>
            ` : ''}

        <div class="${this.showSparklines ? 'sparklines-grid' : 'charts-container'}">
          ${groups.map((g)=>(0, _lit.html)`
              <trace-chart-sk
                .title=${g.title}
                .canvasHeight=${this.showSparklines ? 150 : 300}
                .isSparkline=${this.showSparklines}
                .loading=${this._loading}
                .series=${g.series}
                .dateMode=${this.dateMode}
                .regressions=${this.showRegressions ? this._regressions : {}}
                .normalizeCentre=${this._normalizeCentre}
                .normalizeScale=${this._normalizeScale}
                .hoverMode=${this._hoverMode}
                .smoothingRadius=${this._smoothingRadius}
                .edgeDetectionFactor=${this._edgeDetectionFactor}
                .edgeLookahead=${this._edgeLookahead}
                .showDots=${this._showDots}
                .evenXAxisSpacing=${this._evenXAxisSpacing}
                .showZero=${this._showZero}
                .viewportMinX=${this.viewportMinX}
                .viewportMaxX=${this.viewportMaxX}
                .globalHoverX=${this._globalHoverX}
                .globalPinnedX=${this._globalPinnedX}
                .loadedBounds=${this._loadedBounds}
                .globalBounds=${this._globalBounds}
                .highlightAnomalies=${this.highlightAnomalies}
                .tooltipDiffs=${this._tooltipDiffs}
                .selectedSubrepo=${this._selectedSubrepo}
                .activeSplitKeys=${Array.from(this.splitKeys)}
                .user_id=${this._user}
                .yAxisLabel=${this._determineYAxisTitle(g.series.map((s)=>s.id))}
                @viewport-changed=${this._handleViewportChanged}
                @hover-changed=${this._handleHoverChanged}
                @pin-point=${this._handlePinPoint}
                @toggle-split=${this._handleSplit}
                @reorder-split-keys=${this._handleReorderSplitKeys}
                @toggle-trace=${(e)=>this._handleToggleTrace(e.detail.id)}
                @close-chart=${()=>this._handleCloseChart(g.series.map((s)=>s.id))}>
                <plot-summary-v2-sk
                  slot="summary"
                  ?hidden=${!this._showSummaryBar}
                  .series=${g.series}
                  .domain=${this.dateMode ? 'date' : 'commit'}
                  .viewportMinX=${this.viewportMinX}
                  .viewportMaxX=${this.viewportMaxX}
                  .evenXAxisSpacing=${this._evenXAxisSpacing}
                  .loading=${this._summaryLoading}
                  @summary-range-selected=${this._handleSummaryRangeSelected}
                  @load-more-click=${this._handleLoadMore}>
                </plot-summary-v2-sk>
              </trace-chart-sk>
            `)}
        </div>
      </div>

      <help-hub-sk
        @start-tour=${this._onStartTour}
        @request-random-preset=${this._onApplyRandomPreset}
        @request-comparison-preset=${this._onApplyComparisonPreset}></help-hub-sk>

      <interactive-tour-sk
        .active=${this._tourActive}
        .steps=${this._tourSteps}
        @step-changed=${this._handleTourStepChanged}
        @tour-finished=${()=>{
            this._tourActive = false;
        }}></interactive-tour-sk>

      ${this._workerInitializing ? (0, _lit.html)`
            <div class="worker-init-overlay">
              <div class="spinner"></div>
              <div class="worker-init-status">${this._statusMessage}</div>
            </div>
          ` : ''}
    `;
    }
    constructor(...args){
        super(...args);
        this._queries = [
            {}
        ];
        this.embedded = false;
        this.highlightAnomalies = [];
        this.onlyRegressions = false;
        this.splitAll = false;
        this._queriesExpanded = true;
        this._userToggledExpanded = false;
        this._formulasPerQuery = [
            []
        ];
        this._shortcut = '';
        this._lastQueriesJson = '';
        this._summaryBeginOffsetSec = DEFAULT_SUMMARY_RANGE_SEC;
        this._summaryEndOffsetSec = 0;
        this._lastLoadedShortcut = '';
        this._tourActive = false;
        this._tourSteps = [
            {
                selector: '.workspace',
                title: 'Dynamic Setup',
                text: "Let's start by loading some comparison data.",
                placement: 'bottom'
            },
            {
                selector: 'query-bar-sk',
                title: 'Faceted Search Bar',
                text: 'Type here to search. It supports fuzzy matching.',
                placement: 'bottom'
            },
            {
                selector: '.suggestions-dropdown',
                title: 'Suggestions List',
                text: 'Here you can see the auto-complete suggestions.',
                placement: 'bottom'
            },
            {
                selector: '.multiselect-trigger',
                title: 'Multi-select Chips',
                text: 'Click a chip to see multi-select options.',
                placement: 'bottom'
            },
            {
                selector: '.multiselect-dropdown',
                title: 'Multi-select Dropdown',
                text: 'Here you can select multiple values.',
                placement: 'bottom'
            },
            {
                selector: '.add-query-circle-btn',
                title: 'Multiple Query Rows',
                text: 'Add more rows to compare completely different queries.',
                placement: 'bottom'
            },
            {
                selector: '.config-pill',
                title: 'Toolbar - Split Chart',
                text: 'Split lines into individual graphs.',
                placement: 'bottom'
            },
            {
                selector: '.date-mode-checkbox',
                title: 'Toolbar - Date Mode',
                text: 'Toggle between commit and date axis.',
                placement: 'bottom'
            },
            {
                selector: '.smooth-checkbox',
                title: 'Toolbar - Smoothing',
                text: 'Adjust curve smoothing.',
                placement: 'bottom'
            },
            {
                selector: '.subrepo-select',
                title: 'Toolbar - Subrepos',
                text: 'Filter traces by sub-repository.',
                placement: 'bottom'
            },
            {
                selector: 'trace-chart-sk',
                title: 'Chart Tooltip',
                text: 'Hover over points to see specific values.',
                placement: 'top'
            }
        ];
        this._defaultParamSelections = {};
        this._conditionalDefaults = [];
        this._defaults = null;
        this._workerInitializing = true;
        this._loading = false;
        this._statusMessage = '';
        this._availableParams = [];
        this._optionsByKey = {};
        this._globalAvailableParams = [];
        this._globalOptionsByKey = {};
        this._availableParamsPerQuery = [];
        this._optionsByKeyPerQuery = [];
        this._isCalculatingCounts = false;
        this._suggestionsForQueryBar = [];
        this._latestSuggestRequestIds = [];
        this.splitKeys = new Set();
        this._includeParams = [];
        this._normalizeCentre = 'none';
        this._normalizeScale = 'none';
        this._hoverMode = 'original';
        this._smoothingRadius = 20;
        this.dateMode = false;
        this.showSparklines = false;
        this.pageSize = 10;
        this._edgeDetectionFactor = 1.0;
        this._edgeLookahead = 3;
        this._showDots = true;
        this._seriesData = [];
        this.viewportMinX = null;
        this.viewportMaxX = null;
        this._initialViewportBounds = null;
        this._globalHoverX = null;
        this._globalPinnedX = null;
        this._loadedBounds = {};
        this._globalBounds = {};
        this._selectedSubrepo = 'none';
        this._availableSubrepos = [];
        this._diffBase = null;
        this.showRegressions = true;
        this._summaryLoading = false;
        this._prefetchAbortController = null;
        this._evenXAxisSpacing = false;
        this._showZero = false;
        this._transformPreset = 'none';
        this._tooltipDiffs = false;
        this._smooth = false;
        this._regressions = {};
        this._tracePage = 0;
        this._showSummaryBar = true;
        this._showAllTraces = false;
        this.begin = _const.UNSET_TIME;
        this.end = _const.UNSET_TIME;
        this._user = '';
        this._workerController = null;
        this._latestActiveFacets = [];
        this._viewportChangeTimeout = null;
        this._matchingTraceIds = [];
        this._stateHasChanged = ()=>{};
        this._inFlightMetadataCommits = new Set();
        this._latestRequestId = 0;
        this._debounceDelay = 100;
        this._workerFilterTimer = null;
        this._fetchDataTimer = null;
        this._fetchMetadataTimer = null;
        this._onAnomaliesSourceChanged = ()=>{
            this._seriesData = [];
            this._loadedBounds = {};
            this._globalBounds = {};
            this._regressions = {};
            this._latestRequestId++;
            void this._fetchData(this._latestRequestId);
        };
        this._onAnomalyChanged = (e)=>{
            var _detail_anomalies, _detail, _detail_traceNames, _detail1;
            const detail = e.detail;
            if (((_detail = detail) === null || _detail === void 0 ? void 0 : (_detail_anomalies = _detail.anomalies) === null || _detail_anomalies === void 0 ? void 0 : _detail_anomalies.length) && ((_detail1 = detail) === null || _detail1 === void 0 ? void 0 : (_detail_traceNames = _detail1.traceNames) === null || _detail_traceNames === void 0 ? void 0 : _detail_traceNames.length)) {
                this._updateRegressionsState(detail.anomalies, detail.traceNames);
            }
        };
    }
}, (()=>{
    _ExploreMultiV2Sk.styles = (0, _lit.css)`
    :host {
      display: block;
      padding: 16px;
      font-family: var(--font, 'Inter', system-ui, -apple-system, sans-serif);
      background-color: var(--background);
      color: var(--on-background);
      min-height: 100vh;
    }

    .range-menu {
      background-color: var(--surface);
      border: 1px solid var(--border);
      border-radius: 4px;
      box-shadow:
        0 4px 6px -1px color-mix(in srgb, var(--transparent-overlay) 20%, transparent),
        0 2px 4px -1px color-mix(in srgb, var(--transparent-overlay) 12%, transparent);
      padding: 8px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      z-index: 1000;
    }

    .range-menu button {
      background: none;
      border: none;
      color: var(--on-surface);
      text-align: left;
      padding: 4px 8px;
      cursor: pointer;
      border-radius: 2px;
    }

    .page-loading {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 12px;
      color: var(--on-surface);
      font-size: 16px;
      padding: 40px;
    }

    .spinner {
      width: 32px;
      height: 32px;
      border: 3px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
      border-radius: 50%;
      border-top-color: var(--primary);
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .range-menu button:hover {
      background-color: var(--surface-hover);
    }

    .header {
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    h1 {
      color: var(--primary);
      font-size: 24px;
      font-weight: 800;
      margin: 0;
      letter-spacing: -0.025em;
    }

    .subtitle {
      color: var(--on-surface);
      font-size: 12px;
      margin: 4px 0 0;
    }

    .workspace {
      background: var(--surface);
      backdrop-filter: blur(12px);
      border: 1px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
      color: var(--on-surface);
      border-radius: 12px;
      padding: 12px;
      box-shadow: none;
    }

    .section-title {
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: var(--on-surface);
      margin-bottom: 8px;
    }

    .charts-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 12px;
    }

    .sparklines-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 12px;
      margin-top: 12px;
    }

    .query-row {
      margin-bottom: 6px;
    }

    .add-query-circle-btn {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: var(--surface);
      border: none;
      color: var(--primary);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      box-shadow: 0 2px 4px color-mix(in srgb, var(--transparent-overlay) 20%, transparent);
      transition: all 0.2s;
    }

    .add-query-circle-btn:hover {
      background: var(--surface-variant);
      box-shadow: 0 4px 6px color-mix(in srgb, var(--transparent-overlay) 30%, transparent);
    }

    .config-pills {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      margin: 12px 0;
    }

    .config-pill {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 4px 12px;
      background: color-mix(in srgb, var(--on-surface) 5%, transparent);
      border-radius: 16px;
      font-size: 12px;
      color: var(--on-surface);
      border: 1px solid var(--outline);
    }

    .config-pill.diff-base {
      background: color-mix(in srgb, var(--primary) 15%, transparent);
      border: 1px solid color-mix(in srgb, var(--primary) 30%, transparent);
    }

    .config-pill-label {
      font-weight: 600;
      color: var(--primary);
    }

    .config-pill-value {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .config-pill-remove {
      border: none;
      background: none;
      cursor: pointer;
      font-size: 14px;
      color: var(--on-surface);
      padding: 0;
      margin-left: 4px;
      line-height: 1;
      display: flex;
      align-items: center;
    }

    .config-pill-remove:hover {
      color: var(--on-background);
    }

    .expand-queries-btn {
      background: var(--surface);
      border: 1px solid var(--outline);
      color: var(--on-surface);
      border-radius: 16px;
      padding: 4px 12px;
      font-size: 11px;
      font-weight: 600;
      cursor: pointer;
      box-shadow: 0 2px 4px color-mix(in srgb, var(--transparent-overlay) 20%, transparent);
      transition: all 0.2s;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .expand-queries-btn:hover {
      background: var(--surface-hover);
      border-color: var(--primary);
      color: var(--on-background);
      box-shadow: 0 4px 6px color-mix(in srgb, var(--transparent-overlay) 30%, transparent);
    }

    .worker-init-overlay {
      position: fixed;
      bottom: 24px;
      right: 24px;
      background: var(--surface);
      border: 1px solid var(--border);
      border-radius: 8px;
      box-shadow: 0 4px 12px color-mix(in srgb, var(--transparent-overlay) 60%, transparent);
      padding: 12px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
      z-index: 2000;
    }

    .worker-init-status {
      font-size: 14px;
      font-weight: 500;
      color: var(--on-background);
    }

    .worker-init-overlay .spinner {
      border: 2px solid var(--border);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border-left-color: var(--primary);
      animation: spin 1s linear infinite;
    }
  `;
})(), _ExploreMultiV2Sk);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], ExploreMultiV2Sk.prototype, "queries", null);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "embedded", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "highlightAnomalies", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "onlyRegressions", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "splitAll", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_queriesExpanded", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_formulasPerQuery", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_shortcut", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_tourActive", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], ExploreMultiV2Sk.prototype, "_defaultParamSelections", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_conditionalDefaults", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "_defaults", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_workerInitializing", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_loading", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_statusMessage", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_availableParams", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], ExploreMultiV2Sk.prototype, "_optionsByKey", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_globalAvailableParams", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], ExploreMultiV2Sk.prototype, "_globalOptionsByKey", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_availableParamsPerQuery", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_optionsByKeyPerQuery", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_isCalculatingCounts", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_suggestionsForQueryBar", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof Set === "undefined" ? Object : Set)
], ExploreMultiV2Sk.prototype, "splitKeys", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_includeParams", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ExploreMultiV2Sk.prototype, "_normalizeCentre", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ExploreMultiV2Sk.prototype, "_normalizeScale", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ExploreMultiV2Sk.prototype, "_hoverMode", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_smoothingRadius", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "dateMode", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "showSparklines", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], ExploreMultiV2Sk.prototype, "pageSize", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_edgeDetectionFactor", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_edgeLookahead", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_showDots", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_seriesData", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "viewportMinX", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "viewportMaxX", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "_globalHoverX", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "_globalPinnedX", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], ExploreMultiV2Sk.prototype, "_loadedBounds", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], ExploreMultiV2Sk.prototype, "_globalBounds", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ExploreMultiV2Sk.prototype, "_selectedSubrepo", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_availableSubrepos", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "_diffBase", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], ExploreMultiV2Sk.prototype, "showRegressions", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_summaryLoading", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_evenXAxisSpacing", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_showZero", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_transformPreset", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_tooltipDiffs", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_smooth", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExploreMultiV2Sk.prototype, "_regressions", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_tracePage", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_showSummaryBar", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_showAllTraces", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], ExploreMultiV2Sk.prototype, "begin", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], ExploreMultiV2Sk.prototype, "end", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExploreMultiV2Sk.prototype, "_user", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ExploreMultiV2Sk.prototype, "_matchingTraceIds", void 0);
ExploreMultiV2Sk = _ts_decorate([
    (0, _decorators.customElement)('explore-multi-v2-sk')
], ExploreMultiV2Sk);
